"use strict";

import moment from "moment";
import BatchSelectionModal from "./BatchSelectionModal";
import { CURRENCY } from "../libs/utils/Const";

export class NewOrder {
    constructor() {
        let today = moment(new Date()).format('YYYY-MM-DD');

        this.OriginDocumentCreate = "";
        this.DocType = "I";
        this.DocumentType = "F";
        this.WddStatus = "";
        this.isDocumentWithAuthorization = false;
        this.DocStatus = "";
        this.DocEntry = "";
        this.DocEntryRel = "";
        this.CardCode = "";
        this.Balance = "";
        this.DocNum = "";
        this.UserID = 0;
        this.CreditLine = "";
        this.CardName = "";
        this.CardType = "";
        this.Address = "";
        this.ShipToCode = "";
        this.Address2 = "";
        this.UBIGEO = "";
        this.GroupCode = '';
        this.GroupCodeName = '';
        this.PriceListNum = "";
        this.NextFolio = "";
        this.StatusDocument = "";
        this.NumAtCard = "";
        this.RecoverIdSale = '';
        this.DocCur = "SOL";
        this.SpecialProce = [];
        this.Currencies = [];
        this.DocCurDocumentsPayment = "";
        this.ChangeRate = 1;
        this.SerieName = "";
        this.SerieCode = null;
        this.SerieArray = [];
        this.DocDate = today;
        this.DocDueDate = today;
        this.TaxDate = today;
        this.U_FMB_END_DATE = today;
        this.ReqDate = today;
        this.ReqType = '12';
        this.Requester = '';
        this.ReqName = '';
        this.Branch = '';
        this.BranchName = '';
        this.Department = '';
        this.DepartmentName = '';
        this.CostCenter = '';
        this.Email = '';
        this.Notify = 'N';
        this.isSelectTo = false; // para validacion
        this.isSelectToActive = false; // para validacion copiar a - no actualizar precios
        this.isSelectOf = false; // para validfacion
        this.isSelectOfActive = false; // para validacion copiar de - no actualizar precios
        this.SlpCode = "";
        this.SlpName = "";
        this.CntctCode = "";
        this.CntctName = "";
        this.OwnerCode = "";
        this.Status = "";
        this.OwnerName = "";
        this.Comments = "";
        this.CommentsAccount = ""
        this.Subtotal = 0;
        this.DiscountPercent = 0;
        this.Discount = 0;
        this.TaxeDefaultPartner = '';
        this.TaxeRateDefaultPartner = 0;
        this.TaxNameDefaultPartner = '';
        this.OcrCode2DefaultPartner = '';
        this.AcctCodeDefaultPartner = '';
        this.CogsAcctDefaultPartner = '';
        this.AcctCodeNameDefaultPartner = '';
        this.CogsAcctNameDefaultPartner = '';
        this.Taxes = 0;
        this.Total = 0;
        this.DpmAmnt = 0;
        this.TotalCopy = 0;
        this.Items = [];
        this.ItemsPayments = [];
        this.CheckList = [];
        this.permissions = {};
        this.servicesToUpdate = 1; // 1 = update all  2 = not update all
        this.DefaultAcctCode = '';
        this.metodoPago = 0;
        this.GroupNum = 0;
        this.GroupName = "";
        this.PymCode = "";
        this.PymName = "";
        this.ExtraDays = 0;
        this.Project = '';
        this.LicTradNum = '';

        this.indexRowDetails = ""; // index to details when press any action
        this.LastLineNumItems = -1;
        this.SelectOf = '';

        // Traslados

        this.Filler = "";
        this.FillerName = "";
        this.ToWhsCode = "";
        this.ToWhsCodeName = "";
        this.JrnlMemo = "";
        this.GroupNumTraslado = "";
        this.GroupNumTrasladoName = "";

        this.PickRmrk = '';

        this.wareHouseFinalOptional = false;
        this.wareHouseFinalOptionalValue = "";

        this.Transit = ''; // SET DEFAULT: TRASPASO DIRECTO
        this.DocNumCEDIS = '';
        this.DocEntryCEDIS = '';
        this.WarehouseCEDIS = '';

        //Pagos

        this.TransId = "";
        this.CounterRef = "";
        this.NoDocSum = 0;
        this.BpAct = "";
        this.BpActName = "";
        this.BpActFormatCode = "";

        this.BpActCopy = "";
        this.BpActNameCopy = "";
        this.BpActFormatCodeCopy = "";

        this.PayNoDoc = false;
        this.canCancelIncomingPayment = false;


        this.CashSum = 0;
        this.CreditSum = 0;
        this.CheckSum = 0;
        this.TrsfrSum = 0;
        this.totalRecibido = 0;
        this.totalDocumento = 0;
        this.totalPago = 0;
        //#region CREDIT PERCEPTIONS
        this.totalCreditPerception = 0;
        //#endregion CREDIT PERCEPTIONS
        this.totalRestante = 0;

        this.TrsfrAcct = "";
        this.TrsfrAcctName = "";
        this.TrsfrAcctFormatCode = "";
        this.TrsfrDate = today;
        this.TrsfrRef = "";


        this.CheckAcct = "";
        this.CheckAcctName = "";
        this.CheckAcctFormatCode = "";

        this.CashAcct = "";
        this.CashAcctName = "";
        this.CashAcctFormatCode = "";
        this.PaymentDocType = "C";
        this.isAccountPayment = false;
        this.PrjCode = '';

        //ENTRADA DE MERCANCIA CASCOS       
        this.SerieArray2 = [];
        this.SerieName2 = "";
        this.SerieCode2 = "";
        this.NextFolio2 = "";
        this.DocType2 = "";
        this.Casco = 0;
        this.DocStatusCasco = "";

        //ENTRADA DE MERCANCIA CASCOS       
        this.SerieArray3 = [];
        this.SerieName3 = "";
        this.SerieCode3 = "";
        this.NextFolio3 = "";

        // campo para poder diferenciar  en autorizar y crear auhorizado para traslados
        this.ObjType = "";

        //UserFields

        this.userFields = new UserFields();
        this.userFieldsItem = new UserFieldsItem();
        this.userFieldsHeader = [];
        this.userFieldsBody = [];
        //Propiedar para buscar Item con un Like
        this.searchItem = "";
        //Propuiedad para entrada y salida de Mercancia
        this.Ref2 = '';
        this.service = [];
        this.refreshCascos = false;
        this.partnerSelected = false;
        this.itemSelected = false;
        this.invFields = []; // Campos de usuario de inventario
        this.OPRQFields = []; // Campos de usuario de OPRQ
        this.transferFields = []; // Campos de usuario de OWTQ y OWTR
        this.typeSearchList = [];
        this.formattedMap = {};
        //Validar almacén selecionado
        this.fillWhsSelected = false;
        this.toWhsSelected = false;
        //Cuenta puente y asociada para Entrada casco 
        this.CashAccount = ''; // Cuenta pago
        this.ControlAccount = '';  // Cuenta asociada
        //Nueva vista para selectTo
        this.newView = '';
        this.U_FMB_Auto = '';
        //Nombre del modelo de autorización
        this.StepCode = '';
        this.WtmName = '';
        //Factura de reserva de clientes
        this.ReserveInvoice = 'tNO';
        //Numero de transacion
        this.transactionId = '';
        this.PaidToDate = 0;
        this.BackOrder = '';
        this.PartDelivr = '';
        this.Confirmed = true;
        this.PartSupply = true;
        //#region ######### TIMBRA-ONE ############################################################
        this.U_UDF_UUID = '';
        this.U_FMB_TIPO_REL = '00';
        this.U_FMB_UUID_RELACIONADO = [];
        this.U_FMB_SELLO = '';
        this.U_FMB_FOLIO = '';
        this.U_FMB_SERIE = '';
        this.U_FMB_TIPO_RELACION = [];
        this.IsCancelCFDI = '';
        //#endregion

        //#region ######### CAMPOS EMPRESA ###########################################################

        this.U_TipoSalida = '';
        this.U_TipoSalidaOptions = [];

        this.NeedScopCode = false;
        this.U_FMB_SCOP_CODE = '';
        this.U_LLG_ESTADO_SCOP = '';
        this.U_LLG_PLACA_SCOP = '';
        this.U_LLG_CAPACIDAD_SCOP = '';
        this.U_LLG_FPEDIDO_SCOP = '';
        this.ValidSCOP = false;
        this.U_RS_DENSIDAD = 0;
        this.U_RS_IMP = false;
        this.U_RS_NUMIMP = '';
        this.U_RS_NivelReq = '0';
        // this.RequestInfo = false;
        //#endregion

        this.Addresses = [];
        // Counter
        this.folio = '';
        // Pagos con tarjeta de credito
        this.PaymentsCreditCards = [new CreditCards()];

        this.ToolBar = new ToolBar();

        this.StatusCFDI = false;
        this.IsCancelSAP = false;
        this.Canceled = 'N';

        //#region ######### CARTA PORTE ###########################################################
        this.U_FMB_FOLIO_PORTE = '';
        //#endregion

        // Gestión de Citibanamex
        this.U_FMB_Bank_Status = 'N';

        //DELIVERY AUTHORIZATION
        this.DeliveryAuthorization = 'N';

        //Documento Relacionado
        this.U_FMB_RelatedFolio = '';

        //#region ######### MRP ###########################################################
        this.DpstType = '';
        this.ObjAbs = -1;
        this.FromDate = '';
        this.ToDate = '';
        this.FromDate3 = '';
        this.ToDate3 = '';
        this.ItmFrom1 = '';
        this.ItmTo1 = '';
        this.ItmGroup = '';
        this.CardFrom1 = '';
        this.CardTo1 = '';
        //#endregion

        // Precios de Entrega
        this.AgentCode = '';
        this.AgentName = '';
        this.AgentSelected = false;
        this.DocTotal = 0;
        this.landedCosts = new LandedCosts();

        // FACTURAS DE ANTICIPO DOWNPAYMENTS
        this.PartnerAcctCode = "";
        this.PartnerDpmClear = "";
        this.PartnerDpmIntAct = "";
        this.DownPaymentAmount = 0;
        this.DownPaymentsToDraw = [];
        this.AuxDownPaymentsToDraw = [];

        this.Mail_Creator = '';
        this.Name_Creator = '';
        this.U_FMB_EditTraslado = 'N';
        this.U_FMB_ComTraslado = '';
        this.SendRequestEdition = 'N';
        this.isCreator = 'N';

        this.OPQTDraft = 0;

        // LEYENDAS FISCALES
        this.isLeyendaFiscal = false;
        this.LeyendasFiscales = [];
        this.SelectLeyendas = false;

        // COMERCIO EXTERIOR
        this.isComercioExterior = "N";
        this.ComercioExterior = new ComercioExterior();
        // OXXO REFERENCIAS
        this.IdOxxoRef = -1;

        this.isSalesDocument = false;
        this.isPurchaseDocument = false;
        this.isTransferDocument = false;

        //#region ATTACHMENT
        this.AtcEntry = '';
        this.Attachment = [];
        this.UploadAttachments = [];
        //#endregion ATTACHMENT

        this.searchInvItems = true;

        //#region DIMENSIONS
        this.Dimension1 = '';
        //#endregion DIMENSIONS

        this.WTCodes = []; // Allowed WTax Codes for BP
        //#region DETRACCIONES
        this.DetraccionVista = false; // La vista aplica a detracción
        this.WTCodesD = []; // Allowed WTax Codes for BP
        this.U_STR_AfctoDtr = 'N'; // El documento aplica a detracción
        this.OU_STR_AfctoDtr = 'N'; // El documento del que se esta copiando aplico a detracción
        this.U_RS_MONDET = 0; // Monto detraccion
        this.U_STR_TasaDTR = 0; // %Tasa Detracción
        this.U_STR_CodBnSs = ''; // Cod. de Bien o Servicio

        this.U_FMB_BP_Detra = 'N'; // El sn es sujeto a detracción
        this.existsDetraccion = false; // El documento del que se copia tuvo detracción
        //#endregion DETRACCIONES

        this.U_BPP_MDTS = ''; // Tipo de salida del documento
        this.U_STR_FE_GRE_CodigoMotivoTraslado = ''; // Codigo Motivo Traslado

        //#region RETENCIONES
        this.WTCodesR = []; // Allowed WTax Codes for BP
        this.U_LLG_RETENCI = 'N'; // El documento aplica a retención
        this.RetencionVista = false; // La vista aplica a retención
        this.U_FMB_BP_Reten = 'N'; // El sn es sujeto a retención
        this.U_STR_BC = 'N'; // Buen contribuyente
        this.U_STR_AR = 'N'; // Agente de retencion
        this.U_STR_AP = 'N'; // Agente de percepción
        this.WithHoldingPrev = false; // Prevenir creación de pago si ninguna factura tuvo retención previamente
        this.MONRET = 0; // Monto retenido visual en factura de proveedor
        //#endregion RETENCIONES

        //#region Totals
        //#region Moneda del documento
        this.SubtotalWithoutDiscount = 0;
        this.VatSum = 0;
        //#endregion Moneda del documento

        //#region Moneda local
        this.SubtotalWithoutDiscountLocal = 0;
        this.SubtotalLocal = 0;
        this.DiscountLocal = 0;
        this.TaxesLocal = 0;
        this.TotalLocal = 0;
        this.VatSumLocal = 0;
        this.DocTotalLocal = 0;
        //#endregion Moneda local

        //#region Perceptions
        this.SumTotalPL = 0;
        this.SumQuantitiesP = 0;
        //#region CREDIT PERCEPTIONS
        this.TaxesCredit = 0;
        this.TaxesLocalCredit = 0;
        this.TotalCredit = 0;
        this.TotalLocalCredit = 0;
        this.VatSumCredit = 0;
        this.VatSumLocalCredit = 0;

        this.DocTotalCredit = 0;
        this.DocTotalLocalCredit = 0;

        this.SumTotalPLCredit = 0;
        this.U_STR_FE_Tasa_Percepcion = 0; // Tasa
        this.U_BPP_TtPc = 0;  // Total
        //#endregion CREDIT PERCEPTIONS
        //#endregion Perceptions
        //#endregion Totals

        //#region Flujo de caja
        this.transferCFWId = null; // Para transferencias
        this.needTransferCFW = false; // Para transferencias
        this.transferCFWOptions = []; // Para transferencias

        this.cashCFWId = null; // Para efectivo
        this.needCashCFW = false; // Para efectivo
        this.cashCFWOptions = []; // Para efectivo

        this.checkCFWId = null; // Para cheques
        this.needCheckCFW = false; // Para cheques
        this.checkCFWOptions = []; // Para cheques
        //#endregion Flujo de caja

        //#region Transportes de ORDR
        this.CodigoAutotransporte = '';
        this.CodigoUnidad = '';
        this.PlacaVM = '';
        this.TransportWhs = {};
        //#endregion Transportes de ORDR

        //#region Cuenta de mayor para OIGN y OIGE
        this.InventoryAccount = {};
        //#endregion Cuenta de mayor para OIGN y OIGE

    }
};

export class ApplyDownPayment {
    constructor() {
        this.DocEntry = -1;
        this.AmountToDraw = -1;
        this.DownPaymentType = 'dptInvoice';
    }
}
export class UserFields {
    constructor() {
        this.userFields1 = "";
        this.userFields2 = "";
        this.userFields3 = "";
        this.userFields4 = "";
        this.userFields5 = "";
        this.userFields6 = "";
        this.userFields7 = "";
        this.userFields8 = "";
        this.userFields9 = "";
        this.userFields10 = "";

        this.userFields11 = "";
        this.userFields12 = "";
        this.userFields13 = "";
        this.userFields14 = "";
        this.userFields15 = "";
        this.userFields16 = "";
        this.userFields17 = "";
        this.userFields18 = "";
        this.userFields19 = "";
        this.userFields20 = "";

        this.userFields21 = "";
        this.userFields22 = "";
        this.userFields23 = "";
        this.userFields24 = "";
        this.userFields25 = "";
        this.userFields26 = "";
        this.userFields27 = "";
        this.userFields28 = "";
        this.userFields29 = "";
        this.userFields30 = "";

        this.userFields31 = "";
        this.userFields32 = "";
        this.userFields33 = "";
        this.userFields34 = "";
        this.userFields35 = "";
        this.userFields36 = "";
        this.userFields37 = "";
        this.userFields38 = "";
        this.userFields39 = "";
        this.userFields40 = "";

        this.userFields41 = "";
        this.userFields42 = "";
        this.userFields43 = "";
        this.userFields44 = "";
        this.userFields45 = "";
        this.userFields46 = "";
        this.userFields47 = "";
        this.userFields48 = "";
        this.userFields49 = "";
        this.userFields50 = "";

    }
}

export class UserFieldsItem {
    constructor() {
        this.userFields1 = "";
        this.userFields2 = "";
        this.userFields3 = "";
        this.userFields4 = "";
        this.userFields5 = "";
        this.userFields6 = "";
        this.userFields7 = "";
        this.userFields8 = "";
        this.userFields9 = "";
        this.userFields10 = "";
        this.userFields11 = "";
        this.userFields12 = "";
        this.userFields13 = "";
        this.userFields14 = "";
        this.userFields15 = "";
        this.userFields16 = "";
        this.userFields17 = "";
        this.userFields18 = "";
        this.userFields19 = "";
        this.userFields20 = "";
        this.userFields21 = "";
        this.userFields22 = "";
        this.userFields23 = "";
        this.userFields24 = "";
        this.userFields25 = "";
        this.userFields26 = "";
        this.userFields27 = "";
        this.userFields28 = "";
        this.userFields29 = "";
        this.userFields30 = "";

    }
}

export class NewItem {
    constructor() {
        let today = moment(new Date()).format('YYYY-MM-DD');
        let todayTaxDate = moment(new Date()).format('DD/MM/YYYY');

        this.LineStatus = false; // close false
        this.LineNum = '';
        this.BaseEntry = null;
        this.BaseType = -1;
        this.BaseLine = null;
        this.ItemCode = "";
        this.ItemName = "";
        this.PicturName = '';
        this.UserText = '';
        this.CodeBars = '';
        this.ItmsGrpCod = '';
        this.InvntItem = '';
        this.RevenuesAc = '';
        this.OriginalQuantity = 1;
        this.OriginalQuantityClose = 1;
        this.OpenQty = 0;
        this.Quantity = 1;
        this.HomePrice = 0;
        this.Price = "";
        //Precios para validar promocion
        this.newHomePrice = 0;
        this.newPrice = "";
        //Precio para C100
        this.cHomePrice = 0;
        this.cPrice = "";


        // this.ChangeRate = 1;
        this.Currency = 'SOL';
        this.WhsCode = "";
        this.WhsName = "";
        this.OcrCode = "";
        this.OcrName = "";
        this.OcrCode2 = "";
        this.OcrName2 = "";
        this.OcrCode3 = "";
        this.OcrName3 = "";
        this.OcrCode4 = "";
        this.OcrName4 = "";
        this.OcrCode5 = "";
        this.OcrName5 = "";
        this.TaxCode = "";
        this.TaxeRate = 0;
        this.CogsAcct = '';
        this.AcctCode = '';
        this.AcctCodeName = '';
        this.FormatCode = '';
        this.FormatCode2 = '';
        this.CurrTotal = 0;
        this.CogsAcctName = '';
        this.TaxeResult = 0;
        this.DiscountPercent = 0;
        this.Discount = 0;
        this.Total = 0;
        this.LineTotal = 0;
        this.PricesList = [];
        this.wareHouseStock = [];
        this.stock = true;
        this.DescPago = '';
        //traslados

        this.Filler = "";
        this.FillerName = "";
        this.ToWhsCode = "";
        this.ToWhsCodeName = "";
        this.ItemNew = true;
        //Entrada y saldia de Mercancia
        this.InvntryUom = '';
        this.UomCode = '';
        this.OnHand = 0;
        this.AvgPrice = 0;
        this.NewAvgPrice = 0;
        this.EvalSystem = '';
        //Autorizacion
        this.NoPriceList = '';
        this.UserBaseUn = 'N';
        //cantidad por Paquete
        this.SalUnitMsr = '';
        this.SalPackUn = 0;
        this.PurPackUn = 0;
        //Validacion enter 
        this.whsSelected = false;
        // Proyecto Factura Proveedores
        this.Project = '';
        //Campo para determinar unidad de medida
        this.NumPerMsr = 0;
        //Impueto nivel linea 
        this.ImpuestoRow = null;
        this.UserFieldsItem = new UserFieldsItem();
        this.LineVendor = '';

        this.GPTtlBasPr = 0;
        this.GrossBuyPr = 0;
        this.GrssProfit = 0;

        this.MaxStock = 0;
        this.MinStock = 0;
        this.MinOrder = 0;

        this.SWeight1 = 0;
        this.SWght1Unit = 0;
        this.U_FMB_LineComment = '';

        //#region ########## BATCH #######################
        this.ManBtchNum = 'N';
        this.ItemBatchSelected = false;
        this.DocUoMQty = 1;
        this.SnBUoMQty = 0;
        this.OpenLneQty = 1;
        this.BatchNumbers = [];
        this.AvailableBatchNumbers = [];
        this.FilterBatch = '0';
        //#endregion
        this.TargetType = -1;
        this.TrgetEntry = null;
        this.ActualBaseLine = null;
        this.ActualOpenQty = null;
        this.PrecioKilo = 0;
        this.CacheCounterPrice = 0;
        this.AlternativePriceGP = 0;

        //#region ########## ORDEN DE COMPRA #######################
        this.KilosXComprar = 0;
        this.PesosXPieza = 0;
        this.PrecioXKilo = 0;
        //#endregion

        //#region ################## POINTS CARD ################ ✔
        this.U_FMB_AplicaMonedero = 'N';
        this.U_FMB_VentaMonedero = 'N';
        this.U_FMB_ArtPromo = 'N';
        //#endregion

        this.DISCOUNT_PERIOD_QTY = []
        this.U_FMB_TypeDiscount = null;
        this.SpecPrice = 'R';

        this.U_FMB_CILINDRO = ''
        this.U_FMB_IS_CILINDRO = '0';
        this.DelivrdQty = '';
        this.TaxOnly = 'N';
        this.TaxStatus = 'N';
        // STOCK EN RUTA PARA LOS ZONALES
        this.RutaOnHand = 0;
        this.CUsoOnHandGeneral = 0;
        this.MovimientoDiario = 0;

        //#region Gas Cylinder Management
        this.U_RML_ENTCLNDRO = "";
        this.U_RML_TIPO_CU = "-";
        this.U_RML_CU = "0";
        //#endregion

        //#region ########## Billing Fields ##########
        this.availableIgvOperationList = [];
        this.U_BPP_OPER = "-";
        this.U_tipoOpT12 = "-";
        this.U_STR_FECodAfect = "";
        //#region GALLONS CONVERSION
        this.U_RS_UMED = ''
        this.U_RS_CANTG = 0;
        this.U_RS_PRECIOGL = 0;
        this.U_RS_TOTALGL = 0;
        this.U_RS_DENS = 0;
        this.Gallons = false;
        //#endregion GALLONS CONVERSION
        //#endregion
        this.FromLocationAssignment = [];
        this.ToLocationAssignment = [];
        this.DocumentLinesBinAllocations = [];
        this.BinActivat = 'N';
        this.TotalAsigned = 0;
        this.ToTotalAsigned = 0;
        this.searchLocation = ""; // Propiedad para buscar unibaciones con LIKE
        this.UoMCode = "";
        this.measureUnit = 1;
        this.isAdministrativeExpenseParent = '';
        this.isTemporary = false;
        this.ParentLineNum = null;
        this.BaseQty = 1;
        this.ifChangeUomCode = false;
        this.OpenCreQty = '';
        this.Text = '';
        this.InvQty = '';
        this.PQTReqQty = 0;

        this.ItemTaxCode = null;
        this.ItemTaxCodeName = null;
        this.ItemRate = null;

        //#region DIMENSIONS
        this.Dimension1 = false;
        this.Dimension2 = false;
        this.Dimension3 = false;
        this.Dimension4 = false;
        this.Dimension5 = false;
        //#endregion DIMENSIONS

        //#region DETRACCIONES
        this.U_RML_AFEDET = 'N';     // Afecto a Detraccion
        this.U_RML_CODRET = '';     // Codigo Detraccion / Retención
        this.U_RML_CODSERV = '';    // Codigo de Servicio
        this.U_RML_PORCE = 0;       // Porcentaje Servicio
        //#endregion DETRACCIONES

        //#region CREDIT PERCEPTIONS
        this.isCreditPerception = false;
        this.TaxCodeCredit = '';
        this.TaxNameCredit = '';
        this.TaxeRateCredit = 0;
        this.PerceptionRate = 0;
        //#endregion CREDIT PERCEPTIONS
        this.U_RS_GRUPO = '';
        this.hasHistoricalPrice = false; // OPRQ: Precio histórico
    }

}

export class Batch {
    constructor() {
        this.BatchNumber = '';
        this.ManufacturerSerialNumber = '';
        this.InternalSerialNumber = '';
        this.ExpiryDate = '';
        this.ManufacturingDate = '';
        this.AddmisionDate = '';
        this.Location = null;
        this.Notes = null;
        this.Quantity = '';
        this.BaseLineNumber = '';
        this.TrackingNote = null;
        this.TrackingNoteLine = null;
    }
}

export class DocComments {
    constructor() {
        this.CommentLine = '';
        this.DocComment = '';
        this.ItemCode = '';
    }
}

export class NewService {
    constructor() {
        let today = moment(new Date()).format('YYYY-MM-DD');
        let todayTaxDate = moment(new Date()).format('DD/MM/YYYY');
        this.Currency = 'SOL';
        this.Description = '';
        this.AcctCode = '';
        this.AcctCodeName = null;
        this.TaxCode = "";
        this.Price = 0;
        this.HomePrice = 0;
        this.TaxeRate = 0;
        this.TaxeResult = 0;
        this.Total = "";
        this.NoGlobal = 0;
        this.BaseEntry = null;
        this.BaseType = -1;
        this.ServiceNew = true;
        // Proyecto Factura Proveedores
        this.Project = '';
        //Centros de costos
        this.OcrCode = "";
        this.OcrName = "";
        this.OcrCode2 = "";
        this.OcrName2 = "";
        this.OcrCode3 = "";
        this.OcrName3 = "";
        this.OcrCode4 = "";
        this.OcrName4 = "";
        this.OcrCode5 = "";
        this.OcrName5 = "";
        this.UserFieldsItem = new UserFieldsItem();
    }

}

export class NewItemPayment {
    constructor() {
        this.DocEntry = "";
        this.DocCur = "";
        this.DocNum = "";
        this.DocCur = "";
        this.docType = "";
        this.RefDate = "";
        this.daysLast = "";
        this.Price = "";
        this.CheckAccount = "";
        this.pastDueBalance = "";
        this.total = 0;
        this.totalPago = "";
        this.DocSubType = "";
        this.differentCurrency = false;
        this.saldoVencido = "";
        this.OcrCode = "";
        this.OcrName = "";
        this.OcrCode2 = "";
        this.OcrName2 = "";
        this.OcrCode3 = "";
        this.OcrName3 = "";
        this.OcrCode4 = "";
        this.OcrName4 = "";
        this.OcrCode5 = "";
        this.OcrName5 = "";
        this.U_Parcialidad = "1";
        this.AcctCode = "";
        this.AcctName = "";
        this.Descrip = "";
        this.Memo = "";

        //#region RETENCIONES
        this.U_LLG_RETENCI = 'N'; // Aplicó a retención
        this.WitholdingTaxApplied = 0; // Valor de retención aplicado
        this.DocTotalO = 0; // DocTotal Original
        this.DocTotalOFC = 0; // DocTotalFC Original
        this.totalO = 0; // Total original
        //#endregion RETENCIONES

        //#region CREDIT PERCEPTIONS
        this.TransId = null; // Asiento de Percepción
        this.U_PRC_IMP = 0; // Total - Pagos
        this.originalU_PRC_IMP = 0; // Total Original
        this.isPerception = false;

        this.U_STR_FE_Tasa_Percepcion = 0; // % de percepción grabado - Determinado por calculo
        this.auxOriginalU_PRC_IMP = 0;  // Total original de la percepción - En pagos - Grabado en el documento
        this.auxU_STR_FE_Tasa_Percepcion = 0; // % de percepción grabado - Grabado en el documento
        //#endregion CREDIT PERCEPTIONS
    }
}

export class NewItemCheck {
    constructor() {
        let today = moment(new Date()).format('YYYY-MM-DD');

        this.DueDate = today;
        this.CheckSum = 0;
        this.CountryCod = "";
        this.BankCode = "";
        this.Branch = "";
        this.AcctNum = "";
        this.CheckNum = "";
        this.Trnsfrable = "N";

    }
}

export class Permissions {
    constructor() {
        this.editItems = false;
        this.editEmployee = false;
        this.editOwner = false;
        this.editDiscountDocument = false;
        this.editDiscountLine = false;
    }
}

export class ToolBar {
    constructor() {
        this.ShowAppliedTranactions = false;
        this.ShowPayments = false;
        this.ShowBatchInfo = false;
        this.ShowGrossProfit = false;
    }
}

export class BusinessPartner {
    constructor() {
        this.update = 0;
        this.CardCode = '';
        this.CardType = '';
        this.Balance = 0;
        this.DocCur = '';
        this.DNotesBal = 0;
        this.OrdersBal = 0;
        this.validFor = 'Y';
        this.CardTypeName = '';
        this.CardName = '';
        this.GroupCode = 100; // Dejar vacio junto a GroupCodeName si ya no se usara por defecto
        this.GroupCodeName = 'C01 - Consumidor Final - CF';
        this.Currency = '';
        this.CurrencyName = '';
        this.LicTradNum = '';
        this.Phone1 = '';
        this.Phone2 = '';
        this.E_mail = '';
        this.SlpCode = '';
        this.SlpName = '';
        this.GroupNum = -1; // Dejar vacio junto a GroupNumName si ya no se usara por defecto
        this.GroupNumName = 'Contado';
        this.IntrstRate = 0; // % Intereses por Retraso
        this.PriceListNum = '';
        this.PriceListNumName = '';
        this.Discount = 0; // % Descuento Total
        this.CreditLine = '';
        this.CreditLineShow = CURRENCY + ' 0.00';
        this.DebtLineShow = CURRENCY + ' 0.00';
        this.DebtLine = '';
        this.Territory = '';
        this.TerritoryName = '';
        this.CntctPrsn = '';
        this.CntctPrsnName = '';
        this.ShipToDef = '';
        this.BillToDef = '';
        this.deliveriesAddressEditIndex = null;
        this.invoicesAddressEditIndex = null;
        this.contactEditIndex = null;
        this.DeliveriesAddress = [];
        this.InvoicesAddress = [];
        this.ContactPersons = [];
        this.PayMethodCodes = [];
        this.PymCode = '';
        this.RefDetails = '';
        this.PymCodeName = '';
        this.userFields = new UserFields();
        this.BankAccounts = [];
        this.ChangeGroupNum = false;  //bandera para poder remplazar balores de la condicion de pago
        this.U_RS_Doc1 = '';
        this.U_RS_Doc2 = '';
        this.U_RS_Doc3 = '';
        this.U_RS_Doc4 = '';
        this.U_RS_Doc5 = '';
        this.U_RS_Doc6 = '';

        //Impuesto Finanzas
        this.WTLiable = false;
        this.VatStatus = 'Y';
        this.TaxCode = '';
        this.TaxName = '';
        this.FatherType = 'P';
        this.DebPayAcct = '';
        this.DebPayAcctName = '';

        this.DefaultBankCode = '';
        this.BankCountr = '';
        this.BankCode = '';
        this.DflAccount = '';
        this.DflSwift = '';
        this.DflBranch = '';
        this.BankCtlKey = '';
        this.DflIBAN = '';

        // FILDS TO DOWN PAYMENTS
        this.DownPaymentClearAct = '';
        this.DownPaymentInterimAccount = '';
        this.U_FMB_DescPP = '0.00';
    }
}

export class InventoryModel {
    constructor() {
        this.itemName = '';
        this.itemCode = '';
        this.invntryUom = '';
        this.CardType = '';
        this.CardName = '';
        this.userFields = new UserFields();
        this.Item = null;
        this.Filler = "";
        this.LastLineNumItems = -1;
        this.CardCode = "";
        this.Description = "";
        this.ForeingName = "";
        this.ItemsGroups = "";
        this.UnitMeasuGorup = "";
        this.UnitMeasu = "";
        this.UnitSales = "";
        this.QuantityPackage = "";
        this.Provider = "";
        this.UnitMeasuGorup = "";
        this.wareHouses = [];
        this.FrgnName = '';
        // Datos Ventas
        this.SalUnitMsr = '';
        this.NumInSale = '';
        this.SalPackMsr = '';
        this.SalPackUn = '';
        // Datos Compras
        this.BuyUnitMsr = '';
        this.NumInBuy = '';
        this.PurPackMsr = '';
        this.PurPackUn = '';
        //
        this.ItmsGrpCod = '';
        this.ItmsGrpNam = '';
        this.UgpCode = '';
        this.UgpName = '';
        this.UserText = '';
        this.UgpEntry = -1;
        this.PriceList = '';
        this.PricesList = [];
        this.itemPrice = 0;
        this.CodeBars = '';
        this.QryGroup = (new Map());
        this.itemType = 'I';

        this.SalesUnitWeight = '0';
        this.SalesWeightUnit = '1';
        //bandera para poder remplazar balores de la condicion de pago

        // type of Item valid values Y - N 
        this.PrchseItem = ''; // articulo de compra
        this.SellItem = ''; // articulo de venta
        this.InvntItem = ''; // articulo de inventario

        this.FirmCode = ''; // fabricante
        this.FirmName = ''; // fabricante nombre
    }
}

export class BankAccountModel {
    constructor() {
        this.AbsEntry = '';
        this.CardCode = '';
        this.Country = '';
        this.BankCode = '';
        this.BankName = '';
        this.Account = '';
        this.SwiftNum = '';
        this.Branch = '';
        this.ControlKey = '';
        this.IBAN = '';
        this.CountryCod = '';

        this.Street = '';
        this.Block = '';
        this.ZipCode = '';
        this.City = '';
        this.State = '';
        this.UsrNumber1 = '';
        this.UsrNumber2 = '';
        this.UsrNumber3 = '';
        this.UsrNumber4 = '';
        this.LogInstanc = '';
        this.Building = '';
        this.AliasName = '';
        this.AcctType = '';
        this.BankKey = '';
        this.BIK = '';
        this.AcctName = '';
        this.CorresAcct = '';
        this.Phone = '';
        this.Fax = '';
        this.ISRType = '';
        this.ISRBillerI = '';
        this.CustIdNum = '';
        this.AddrType = '';
        this.StreetNo = '';
        this.ABARoutNum = '';
        this.MandateID = '';
        this.SignDate = '';
        this.PWZAbsEntr = '';
        this.BranchChk = '';
    }
}

export class QueryModel {
    constructor() {
        this.tableName = '';
        this.idCheck = 0;
        this.query = '';
        this.queryName = '';
    }
}

export class ContactPersons {
    constructor() {
        this.CntctCode = null;
        this.CardCode = '';
        this.Name = '';
        this.Active = 'Y';
        this.FirstName = '';
        this.Title = '';
        this.MiddleName = '';
        this.Position = '';
        this.LastName = '';
        this.Address = '';
        this.Tel1 = '';
        this.Tel2 = '';
        this.Cellolar = '';
        this.Fax = '';
        this.E_MailL = '';
        this.EmlGrpCode = '';
        this.Pager = '';
        this.Notes1 = '';
        this.Notes2 = '';
        this.Password = '';
        this.Gender = '';
        this.Profession = '';
        this.DateOfBirth = '';
        this.CnAddrType = '';
        this.U_AvalSN = '';
    }
}

export class Addresses {
    constructor() {
        this.Address = '';
        this.Street = '';
        this.Block = '';
        this.City = '';
        this.ZipCode = '';
        this.County = '';
        this.State = '';
        this.Country = '';
        this.TaxCode = '';
        this.StreetNo = '';
        this.Building = '';
        this.GlblLocNum = '';
        this.TaxOffice = '';
        this.LineNum = '';
        this.TypeOfAddress = '';


        this.LineNum = '';
        this.TypeOfAddress = '';


    }
}

//#region InventoryCounting
export class InventoryCounting {
    constructor() {
        this.ObjectType = '1470000065';
        this.DocumentEntry = -1;
        this.DocumentNumber = '';
        this.Series = '';
        this.SeriesName = '';
        this.CountDate = '';
        this.CountTime = '';
        this.SingleCounterType = 12;
        this.SingleCounterID = 0;
        this.SingleCounterName = '';
        this.DocumentStatus = '';
        this.Remarks = '';
        this.Reference2 = '';
        this.CountingType = 1;
        this.TeamCountersQty = 0;
        this.TeamCounters = [];
        this.IndividualCountersQty = 0;
        this.IndividualCounters = [];
        this.InventoryCountingLines = [];

        //#region variables de control
        this.PrevSingleCounterName = "";
        //#endregion
    }
}
export class InventoryCounter {
    constructor() {
        this.CounterID = '';
        this.CounterType = '';
        this.CounterName = '';
        this.CountedQuantity = '0.000';

        //#region variables de control
        this.PrevCountedQty = 0;
        //#endregion
    }
}
export class InventoryCountingLine {
    constructor() {
        this.UseLocations = false;
        this.DocumentEntry = -1;
        this.LineNumber = 0;
        this.ItemCode = '';
        this.ItemDescription = '';
        this.Freeze = 'N';
        this.WarehouseCode = '';
        this.BinEntry = '';
        this.BinCode = '';
        this.InWarehouseQuantity = '0.000';
        this.Counted = 'N';
        this.CountedQuantity = '0.000';
        this.Variance = '0.000';
        this.VariancePercentage = '0.000';
        this.VisualOrder = 0;
        this.ProjectCode = '';
        this.Remarks = '';
        this.LineStatus = '';
        this.CounterType = 12;
        this.CounterID = -1;
        this.IndividualCounters = [];
        this.InventoryCountingLineUoMs = [];
        this.InventoryCountingSerialNumbers = [];
        this.InventoryCountingBatchNumbers = [];
        this.WarehousesStocks = [];

        //#region variables de control
        this.PrevWarehouseCode = "";
        this.PrevBinCode = "";
        this.PrevCountedQty = 0;
        //#endregion
    }
}
//#endregion

//#region InventoryPosting
export class InventoryPosting {
    constructor() {
        this.ObjectType = '10000071';
        this.DocumentEntry = -1;
        this.DocumentNumber = -1;
        this.Series = 0;
        this.SeriesName = "";
        this.PostingDate = "";
        this.CountDate = "";
        this.CountTime = "";
        this.Remarks = "";
        this.Reference2 = null;
        this.PriceSource = "3";
        this.PriceList = -1;
        this.JournalRemark = "";
        this.InventoryPostingLines = [];
    }
}
export class InventoryPostingLine {
    constructor() {
        this.DocumentEntry = -1;
        this.LineNumber = 0;
        this.ItemCode = "";
        this.ItemDescription = "";
        this.WarehouseCode = null;
        this.InWarehouseQuantity = "0.000";
        this.Variance = "0.000";
        this.VariancePercentage = "0.0000";
        this.CountedQuantity = "0.000";
        this.Price = "0.00";
        this.Total = "0.00";
        this.BaseEntry = null;
        this.BaseLine = null;
        this.BaseType = null;
        this.Remarks = null;
        this.InventoryPostingLineUoMs = [];
        this.InventoryPostingSerialNumbers = [];
        this.InventoryPostingBatchNumbers = [];
    }
}
//#endregion

// COUNTER
export class NewOrderSales {
    constructor() {
        let today = moment(new Date()).format('YYYY-MM-DD');
        this.OriginDocumentCreate = "";
        this.DocType = "I";
        this.DocumentType = "F";
        this.WddStatus = "";
        this.DocStatus = "";
        this.DocEntry = "";
        this.DocEntryRel = "";
        this.CardCode = "";
        this.Balance = "";
        this.DocNum = "";
        this.UserID = 0;
        this.CreditLine = "";
        this.Credit = 0;
        this.CreditLine = 0;
        this.AvailableCredit = 0;
        this.IsCredit = false;
        this.CardName = "";
        this.Address = "";
        this.ShipToCode = "";
        this.PayToCode = ""
        this.ShipToDef = '';
        this.BillToDef = '';
        this.Address2 = "";
        this.GroupCode = '';
        this.GroupCodeName = '';
        this.PriceListNum = "";
        this.NextFolio = "";
        this.next_Folio_Cons = "";
        this.StatusDocument = "";
        this.NumAtCard = "";
        this.ItsRecoverDoc = "N";
        this.ItsRecoverDeliveryInvoice = false;
        this.DocCur = "SOL";
        this.SpecialProce = [];
        this.Currencies = [];
        this.DocCurDocumentsPayment = "";
        this.ChangeRate = 1;
        this.SerieName = "";
        this.SerieCode = null;
        this.SerieArray = [];
        this.DocDate = today;
        this.DocDueDate = today;
        this.TaxDate = today;
        this.ReqDate = today;
        this.ReqType = '12';
        this.Requester = '';
        this.ReqName = '';
        this.Branch = '';
        this.BranchName = '';
        this.Department = '';
        this.DepartmentName = '';
        this.Email = '';
        this.Notify = 'N';
        this.isSelectTo = false; // para validacion
        this.isSelectToActive = false; // para validacion copiar a - no actualizar precios
        this.isSelectOf = false; // para validfacion
        this.isSelectOfActive = false; // para validacion copiar de - no actualizar precios
        this.SlpCode = "";
        this.SlpName = "";
        this.CntctCode = "";
        this.CntctName = "";
        this.OwnerCode = "";
        this.Status1 = "";
        this.OwnerName = "";
        this.Comments = "";
        this.CommentsAccount = ""
        this.U_FMB_RelatedFolio = '';
        this.Subtotal = 0;
        this.DiscountPercent = 0;
        this.Discount = 0;
        this.TaxeDefaultPartner = '';
        this.TaxeRateDefaultPartner = 0;
        this.TaxNameDefaultPartner = '';
        this.OcrCode2DefaultPartner = '';
        this.AcctCodeDefaultPartner = '';
        this.CogsAcctDefaultPartner = '';
        this.AcctCodeNameDefaultPartner = '';
        this.CogsAcctNameDefaultPartner = '';
        this.Taxes = 0;
        this.Total = 0;
        this.auxTotal = 0;
        this.TotalMoneyMovement = 0;
        this.DpmAmnt = 0;
        this.AvailableAmount = 0;
        this.RemainingAmount = 0;
        this.Items = [];
        this.TaxCode = '';
        this.TaxName = '';
        this.TaxRate = 0;
        this.ItemsPayments = [];
        this.CheckList = [];
        this.permissions = {};
        this.servicesToUpdate = 1; // 1 = update all  2 = not update all
        this.DefaultAcctCode = '';
        this.metodoPago = 0;
        this.GroupNum = 0;
        this.GroupName = "";
        this.PymCode = "";
        this.PymName = "";
        this.ExtraDays = 0;
        this.TckFolio = "";

        this.indexRowDetails = ""; // index to details when press any action
        this.LastLineNumItems = -1;
        this.SelectOf = '';
        this.ScopCode = ""; // llamagas
        // Traslados

        this.Filler = "";
        this.FillerName = "";
        this.ToWhsCode = "";
        this.ToWhsCodeName = "";
        this.JrnlMemo = "";
        this.GroupNumTraslado = "";
        this.GroupNumTrasladoName = "";

        this.PickRmrk = '';

        this.wareHouseFinalOptional = false;
        this.wareHouseFinalOptionalValue = "";

        //Pagos

        this.TransId = "";
        this.CounterRef = "";
        this.NoDocSum = 0;
        this.BpAct = "";
        this.BpActName = "";
        this.BpActFormatCode = "";

        this.BpActCopy = "";
        this.BpActNameCopy = "";
        this.BpActFormatCodeCopy = "";

        this.PayNoDoc = false;
        // PAY THE BILL
        this.PaymentsToSale = [];
        this.PaymentsToReturn = [];
        this.MoneyMovements = [];
        this.RelatedPayMethodsByDoc = [];
        this.CashSum = 0;
        this.CheckSum = 0;
        this.TrsfrSum = 0;
        this.CreditSum = 0;


        this.idSession = '';


        this.TotalRecibido = 0;
        this.TotalDocumento = 0;
        this.TotalPago = 0;
        this.TotalRestante = 0;

        this.TrsfrAcct = "";
        this.TrsfrAcctName = "";
        this.TrsfrAcctFormatCode = "";
        this.TrsfrDate = today;
        this.TrsfrRef = "";


        this.CheckAcct = "";
        this.CheckAcctName = "";
        this.CheckAcctFormatCode = "";

        this.CashAcct = "";
        this.CashAcctName = "";
        this.CashAcctFormatCode = "";



        this.ObjType = "deliveries";

        //UserFields

        this.userFields = new UserFields();
        this.userFieldsItem = new UserFieldsItem();
        //Propiedar para buscar Item con un Like
        this.searchItem = "";
        //Propuiedad para entrada y salida de Mercancia
        this.Ref2 = '';
        this.service = [];
        this.refreshCascos = false;
        this.partnerSelected = false;
        this.itemSelected = false;
        //Validar almacén selecionado
        this.fillWhsSelected = false;
        this.toWhsSelected = false;
        //Cuenta puente y asociada para Entrada casco 
        this.CashAccount = ''; // Cuenta pago
        this.ControlAccount = '';  // Cuenta asociada
        //Nueva vista para selectTo
        this.newView = '';
        this.U_FMB_Auto = '';
        //Nombre del modelo de autorización
        this.StepCode = '';
        this.WtmName = '';
        //Factura de reserva de clientes
        this.ReserveInvoice = 'tNO';
        //Numero de transacion
        this.transactionId = '';
        this.PaidToDate = 0;
        this.BackOrder = '';
        this.PartDelivr = '';
        this.Confirmed = true;
        this.PartSupply = true;




        // FACTURAS DE ANTICIPO DOWNPAYMENTS
        this.PartnerAcctCode = "";
        this.PartnerDpmClear = "";
        this.PartnerDpmIntAct = "";
        this.DownPaymentAmount = 0;
        this.DownPaymentsToDraw = [];
        this.AuxDownPaymentsToDraw = [];
        // Pagos con tarjeta de credito
        this.PaymentsCreditCards = [new CreditCards()];

        // CFDI y REGIMEN FISCAL
        this.USOCFDI = '';
        this.RegimenFiscal = '';
        // Metodo de pago
        this.U_SO1_02METODOPAGO = '';
        this.U_SO1_02FORMAPAGO = '';
        // TIMBRA
        this.U_FMB_TIPO_REL = '00';
        this.U_FMB_USO_CFDI = '';
        this.U_FMB_UUID_RELACIONADO = '';
        this.U_FMB_AUX_CARDNAME = '';


        this.isDocumentWithAuthorization = false;
        this.infoAuthorization = {};
        this.OutstandingBalance = 0;
        this.ReserveDelivery = false;
        this.isDeliveryInvoice = false;

        // 
        this.AddressExtension = {
            ShipToStreet: '',
            ShipToBlock: '',
            ShipToCity: '',
            ShipToZipCode: '',
            ShipToCounty: '',
            ShipToCountry: 'MX',
            ShipToState: '',
            //
            BillToStreet: '',
            BillToBlock: '',
            BillToCity: '',
            BillToZipCode: '',
            BillToCounty: '',
            BillToCountry: 'MX',
            BillToState: '',
        };

        this.FailData = false;
        this.LoadDataForDocFields = false;
        this.AuxViewCounter = '';
        this.ComingFromRecoverQT = false;
        this.OriginDoc = '';
        this.ComingFromRecoverModifiedDoc = false;
        this.AuxDocTotal = 0.0;

        //DELIVERY AUTHORIZATION
        this.DeliveryAuthorization = 'N'
        this.cardSumAmount = 0;
        this.flagPayWithTerminal = false;
        this.payWithTerminalInfo = [];

        // ################## POINTS CARD ################ ✔
        this.flagPointsCard = false;
        this.totalPoints = 0;
        this.valorPunto = 0;
        this.U_FMB_ValidoMonedero = 'N';
        // ################## END POINTS CARD ############### ✔
        this.UUID_RELACIONADO = '';


        // ################## SCOP CODE ################ ✔
        this.NeedScopCode = false;
        this.U_FMB_SCOP_CODE = '';
        this.U_LLG_ESTADO_SCOP = '';
        this.U_LLG_PLACA_SCOP = '';
        this.U_LLG_CAPACIDAD_SCOP = '';
        this.U_LLG_FPEDIDO_SCOP = '';
        this.ValidSCOP = false;
        // ################## END SCOP CODE ############### ✔

        //#region ########## Billing Fields ##########
        this.U_STR_AfctoDtr = "";
        this.U_STR_CodBnSs = "";
        this.U_STR_TazaDtr = "";
        //#endregion

        this.Project = '';

        //#region CREDIT PERCEPTIONS
        this.SumTotalPLCredit = 0;
        this.U_STR_FE_Tasa_Percepcion = 0; // Tasa
        this.U_BPP_TtPc = 0;  // Total
        //#endregion CREDIT PERCEPTIONS

        this.waitForNewSDirection = false;
    }
}

export class PaymentCardsInfo {
    // this comments its example info
    constructor() {
        this.statusOp = ""; //approved
        this.NOperacion = ""; //100604343
        this.NAutorizacion = ""; //213947
        this.CDResp = ""; // 0C
        this.Ref = ""; //Prueba FMB
        this.Arqc = ""; //BD6171103A5DF556
        this.Aid = ""; //A0000000031010
        this.AidLabel = ""; //CREDITO / TARJETAS DEL FUTURO / Visa
        this.getRspDsOperationType = ""; //VENTA
    }
}

export class BusinessPartnerPS {
    constructor() {
        this.CardCode = '';
        this.CardType = 'C';
        this.Balance = 0;
        this.DocCur = '';
        this.DNotesBal = 0;
        this.OrdersBal = 0;
        this.validFor = 'Y';
        this.CardTypeName = '';
        this.CardName = '';
        this.CardLastName = '';
        this.GroupCode = '';
        this.GroupCodeName = '';
        this.Currency = '';
        this.CurrencyName = '';
        this.LicTradNum = '';
        this.Phone1 = '';
        this.Phone2 = '';
        this.E_mail = '';
        this.SlpCode = '-1';
        this.SlpName = '';
        this.GroupNum = '-1';
        this.GroupNumName = '';
        this.PriceListNum = '';
        this.PriceListNumName = '';
        this.CreditLine = '';
        this.Credit = 0;
        this.DebtLine = '';
        this.Territory = '';
        this.TerritoryName = '';
        this.CntctPrsn = '';
        this.CntctPrsnName = '';
        this.ShipToDef = '';
        this.BillToDef = '';
        this.deliveriesAddressEditIndex = null;
        this.invoicesAddressEditIndex = null;
        this.contactEditIndex = null;
        this.DeliveriesAddress = [];
        this.InvoicesAddress = [];
        this.ContactPersons = [];
        this.PayMethodCodes = [];
        this.PymCode = '';
        this.RefDetails = '';
        this.PymCodeName = '';
        this.userFields = new UserFields();
        this.BankAccounts = [];
        this.ChangeGroupNum = false;  //bandera para poder remplazar balores de la condicion de pago

        //Impuesto Finanzas
        this.WTLiable = false;
        this.VatStatus = 'Y';
        this.TaxCode = '';
        this.TaxName = '';
        this.TaxRate = '';
        this.FatherType = 'P';
        this.DebPayAcct = '';
        this.DebPayAcctName = '';

        this.DefaultBankCode = '';
        this.BankCountr = '';
        this.BankCode = '';
        this.DflAccount = '';
        this.DflSwift = '';
        this.DflBranch = '';
        this.BankCtlKey = '';
        this.DflIBAN = '';

        // EMPRESA
        this.U_FMB_USO_CFDI = '';

        this.billAddress = new BillAddress();
        this.shipAddress = new ShipAddress();
    }
}
// userFields Dinamic

export class AdministratorUsers {
    constructor() {
        this.update = 0;

        this.USERID = '';
        this.USER_CODE = '';
        this.U_NAME = '';
        this.E_Mail = '';
        this.U_FMB_passwd = '';

        this.U_FMB_passwdDecrypt = '';
        this.U_FMB_passwdNew = '';
        this.U_FMB_passwdConfirm = '';

        this.U_FMB_role = '';
        this.U_FMB_UserFields = '';

        this.U_FMB_ValidateSeriesOINV = '';
        this.U_FMB_ValidateSeriesORDR = '';
        this.U_FMB_ValidateSeriesODLN = '';
        this.U_FMB_ValidateSeriesORDN = '';
        this.U_FMB_ValidateSeriesORCT = '';
        this.U_FMB_ValidateSeriesOWTR = '';
        this.U_FMB_ValidateSeriesDN = '';
        this.U_FMB_ValidateSeriesORIN = '';
        this.U_FMB_ValidateSeriesOWTQ = '';
        this.U_FMB_ValidateSeriesOIGN = '';
        this.U_FMB_ValidateSeriesOIGE = '';
        this.U_FMB_ValidateSeriesOPOR = '';
        this.U_FMB_ValidateSeriesOPRQ = '';
        this.U_FMB_ValidateSeriesORPD = '';
        this.U_FMB_ValidateSeriesOMRV = '';
        this.U_FMB_ValidateSeriesOPDN = '';
        this.U_FMB_ValidateSeriesOVPM = '';
        this.U_FMB_ValidateSeriesOPCH = '';
        this.U_FMB_ValidateSeriesORPC = '';
        this.U_FMB_ValidateSeriesOQUT = '';

        this.U_FMB_Modulos = '';
        this.U_FMB_CC = '';
        this.U_FMB_Sucursal = '';
        this.U_FMB_Caja = '';
        this.U_CardCode = '';
        this.U_Active = 'Y';
        this.U_SlpCode = -1;

        this.itemsDashboard = [];
        this.series = [];
        this.newSeries = [];
        this.OldPassword = '';

        this.U_Discount = 0;

        this.U_FMB_ConfigModules = '';
        this.U_FMB_CounterRol = '';
        this.CounterPermission = new CounterPermissions();
        this.BranchPermission = new BranchPermission();

        this.user_MIT = "";
        this.pass_MIT = "";
        this.user_MIT_decrypt = "";
        this.pass_MIT_decrypt = "";
        this.new_user_MIT = "";
        this.new_pass_MIT = "";


        this.walletPermissions = [];
        this.U_FMB_UserId = '';
    }
}

export class Employee {
    constructor() {
        this.update = 0;
        this.EmployeeID = '';
        this.SalesEmployeeCode = '';
        this.FirstName = '';
        this.LastName = '';
        this.eMail = '';
        this.Active = 'Y';
        this.Role = '';
        this.Password = '';
        this.Sucursal = '';
        this.CardCode = '';
        this.Caja = '';
        this.Gender = 'E';
        this.DateOfBirth = '';
        this.MobilePhone = '';
        this.PasswordDecrypt = '';
        this.PasswordNew = '';
        this.PasswordConfirm = '';
        this.OldPassword = '';
        // direccion de trabajo
        this.WorkStreet = '';
        this.WorkStreetNumber = '';
        this.WorkBlock = '';
        this.WorkBuildingFloorRoom = '';
        this.WorkZipCode = '';
        this.WorkCity = '';
        this.WorkCounty = '';
        this.WorkStateCode = '';
        this.WorkCountryCode = '';
        // direccion de casa
        this.HomeStreet = '';
        this.HomeStreetNumber = '';
        this.HomeBlock = '';
        this.HomeBuildingFloorRoom = '';
        this.HomeZipCode = '';
        this.HomeCity = '';
        this.HomeCounty = '';
        this.HomeState = '';
        this.HomeCountry = '';
    }
}

export class Sucursal {
    constructor() {
        this.Nombre = '';
        this.Code = '';
        this.Direccion = '';
        this.Cp = 0;
        this.Telefono = '';
        this.Clientes = '';
        this.Project = '';
        //isBorder
        this.isBorder = '';
        this.TimeZone = '';

        // PRICELIST BY MODULE
        this.U_FMB_DEF_PLInventoryGenExitService = '';
        this.U_FMB_DEF_PLInventoryGenEntryService = '';
        this.U_FMB_PLPrintTags = '';

        this.U_FMB_DEF_PLStockTransfer = '';
        this.U_FMB_DEF_PLReqStockTransfer = '';

        this.ListWhs = [];
        this.ListPartners = [];
        this.ListPayMethods = [];

        //SERIES DE DOCUMENTOS
        this.U_FMB_ValidateSeriesOINV = '';
        this.U_FMB_ValidateSeriesORDR = '';
        this.U_FMB_ValidateSeriesODLN = '';

        this.U_FMB_ValidateSeriesORDN = '';
        this.U_FMB_ValidateSeriesORCT = '';
        this.U_FMB_ValidateSeriesOWTR = '';

        this.U_FMB_ValidateSeriesDN = '';
        this.U_FMB_ValidateSeriesORIN = '';
        this.U_FMB_ValidateSeriesOWTQ = '';

        this.U_FMB_ValidateSeriesOIGN = '';
        this.U_FMB_ValidateSeriesOIGE = '';
        this.U_FMB_ValidateSeriesOPOR = '';

        this.U_FMB_ValidateSeriesOPRQ = '';
        this.U_FMB_ValidateSeriesORPD = '';
        this.U_FMB_ValidateSeriesOMRV = '';

        this.U_FMB_ValidateSeriesOPDN = '';
        this.U_FMB_ValidateSeriesOVPM = '';
        this.U_FMB_ValidateSeriesOPCH = '';

        this.U_FMB_ValidateSeriesORPC = '';
        this.U_FMB_ValidateSeriesDM = '';
        this.U_FMB_ValidateSeriesOQUT = '';

        this.U_FMB_ValidateSeriesODPI = '';
        this.U_FMB_ValidateSeriesOIPF = '';

        this.U_FMB_ValidateSeriesOWOR = ''; // orden de prod
        this.U_FMB_ValidateSeriesODPO = ''; // facturas de anticipo de proveedores

        this.U_FMB_SeriesInventoryGenExits = ''; // EMISION 
        this.U_FMB_SeriesInventoryGenEntries = ''; // RECEPCION
        this.U_FMB_SeriesSugerido = ''; // SUGERIDO DE RESURTIDO

        this.U_FMB_ValidateSeriesOPQT = '';


        //VENTAS->INVENTARIO
        this.LimitLines = 0;
        this.U_FMB_DEF_PLPriceMin = '';
        this.U_FMB_DEF_PLBasePrice = '';

        // this.PLVal3 = '';
        this.series = [];
        this.newSeries = [];
        this.ConsecutiveDocs = [
            {
                TypeDocId: 'DL',
                TypeDocLoopId: 'DL_Loop',
                ThTitle: 'VENTAS NOTA DE VENTA (DL)',
                TypeDoc: 0,
                TypeDocLoop: 0,
            },
            {
                TypeDocId: 'DH',
                TypeDocLoopId: 'DH_Loop',
                ThTitle: 'VENTAS A DOMICILIO (DH)',
                TypeDoc: 0,
                TypeDocLoop: 0,
            },
            {
                TypeDocId: 'DR',
                TypeDocLoopId: 'DR_Loop',
                ThTitle: 'ENTREGAS DE FACTURAS DE RESERVA (DR)',
                TypeDoc: 0,
                TypeDocLoop: 0,
            },
            {
                TypeDocId: 'RT',
                TypeDocLoopId: 'RT_loop',
                ThTitle: 'DEVOLUCIONES  (RT)',
                TypeDoc: 0,
                TypeDocLoop: 0,
            },
            {
                TypeDocId: 'QT',
                TypeDocLoopId: 'QT_Loop',
                ThTitle: 'COTIZACIONES (QT)',
                TypeDoc: 0,
                TypeDocLoop: 0,
            },
            {
                TypeDocId: 'ORD',
                TypeDocLoopId: 'ORD_Loop',
                ThTitle: 'PEDIDOS (ORD)',
                TypeDoc: 0,
                TypeDocLoop: 0,
            },

            {
                TypeDocId: 'NM',
                TypeDocLoopId: 'NM_Loop',
                ThTitle: 'NOTAS DE MOSTRADOR (NM)',
                TypeDoc: 0,
                TypeDocLoop: 0,
            },
            {
                TypeDocId: 'IV',
                TypeDocLoopId: 'IV_Loop',
                ThTitle: 'FACTURAS (IV)',
                TypeDoc: 0,
                TypeDocLoop: 0,
            },
            {
                TypeDocId: 'IH',
                TypeDocLoopId: 'IH_Loop',
                ThTitle: 'FACTURAS A DOMICILIO (IH)',
                TypeDoc: 0,
                TypeDocLoop: 0,
            },
            {
                TypeDocId: 'IRCO',
                TypeDocLoopId: 'IRCO_Loop',
                ThTitle: 'FACTURAS DE RESERVA AL CONTADO (IRCO)',
                TypeDoc: 0,
                TypeDocLoop: 0,
            },
            {
                TypeDocId: 'IRCR',
                TypeDocLoopId: 'IRCR_Loop',
                ThTitle: 'FACTURAS DE RESERVA A CREDITO (IRCR)',
                TypeDoc: 0,
                TypeDocLoop: 0,
            },
            {
                TypeDocId: 'DP',
                TypeDocLoopId: 'DP_Loop',
                ThTitle: 'FACTURAS DE ANTICIOS (DP)',
                TypeDoc: 0,
                TypeDocLoop: 0,
            },
            {
                TypeDocId: 'CN',
                TypeDocLoopId: 'CN_Loop',
                ThTitle: 'NOTAS DE CREDITO  (CN)',
                TypeDoc: 0,
                TypeDocLoop: 0,
            },
            {
                TypeDocId: 'ID',
                TypeDocLoopId: 'ID_Loop',
                ThTitle: 'NOTAS DE DEBITO  (ID)',
                TypeDoc: 0,
                TypeDocLoop: 0,
            },
            {
                TypeDocId: 'IP',
                TypeDocLoopId: 'IP_Loop',
                ThTitle: 'PAGOS RECIBIDOS COBRANZA (IP)',
                TypeDoc: 0,
                TypeDocLoop: 0,
            },
            {
                TypeDocId: 'JE',
                TypeDocLoopId: 'JE_Loop',
                ThTitle: 'ASIENTOS CONTABLES(JE)',
                TypeDoc: 0,
                TypeDocLoop: 0,
            },
            {
                TypeDocId: 'MI',
                TypeDocLoopId: 'MI_Loop',
                ThTitle: 'INGRESOS DE METODOS DE PAGO (MI)',
                TypeDoc: 0,
                TypeDocLoop: 0,
            },
            {
                TypeDocId: 'MO',
                TypeDocLoopId: 'MO_Loop',
                ThTitle: 'EGRESOS DE METODOS DE PAGO (MO)',
                TypeDoc: 0,
                TypeDocLoop: 0,
            },
            {
                TypeDocId: 'IM',
                TypeDocLoopId: 'IM_Loop',
                ThTitle: 'FACTURA DE MOSTRADOR GLOBAL (IM)',
                TypeDoc: 0,
                TypeDocLoop: 0,
            },
            {
                TypeDocId: 'IC',
                TypeDocLoopId: 'IC_Loop',
                ThTitle: 'FACTURA DE CONSOLIDADO GLOBAL (IC)',
                TypeDoc: 0,
                TypeDocLoop: 0,
            },
            {
                TypeDocId: 'CM',
                TypeDocLoopId: 'CM_Loop',
                ThTitle: 'NOTA DE CREDITO MOSTRADOR GLOBAL (CM)',
                TypeDoc: 0,
                TypeDocLoop: 0,
            },
            {
                TypeDocId: 'CC',
                TypeDocLoopId: 'CC_Loop',
                ThTitle: 'NOTA DE CREDITO CONSOLIDADO GLOBAL (CC)',
                TypeDoc: 0,
                TypeDocLoop: 0,
            },



        ]

        this.manager_Email = '';

        this.U_FMB_ValidateSeriesSUNAT = '';
        this.U_FMB_ValidateSeriesPUERTA = '';
        this.Type = '';
    }
}

export class PrintDocument {
    constructor() {
        this.docHeader = {
            infoByFolio: new InfoByFolio(),
            responseHeader: new ResponseHeader(),
            billAddress: new BillAddress(),
            shipAddress: new ShipAddress()
        };
        this.docLines = [];
    }
}

export class BillAddress {
    constructor() {
        this.Address = '';
        this.AdresType = '';
        this.Block = '';
        this.City = '';
        this.County = '';
        this.LineNum = '';
        this.Street = '';
        this.ZipCode = '';
    }
}

export class ShipAddress {
    constructor() {
        this.Address = '';
        this.AdresType = '';
        this.Block = '';
        this.City = '';
        this.County = '';
        this.LineNum = '';
        this.Street = '';
        this.ZipCode = '';
    }
}

export class InfoByFolio {
    constructor() {
        this.CashSum = '';
        this.CheckSum = '';
        this.CreditSum = '';
        this.TrsfrSum = '';
        this.cardCode = '';
        this.docDate = '';
        this.docEntry = '';
        this.docNum = '';
        this.docObjectType = '';
        this.docStatus = '';
        this.docTime = '';
        this.docTotal = '';
        this.folio = '';
        this.idSale = '';
        this.idSession = '';
        this.serie = '';
        this.taxTotal = '';
        this.userID = '';
    }
}

export class ResponseHeader {
    constructor() {
        this.BillDirection = '';
        this.CardCode = '';
        this.CardName = '';
        this.Cellular = '';
        this.DiscPrcnt = '';
        this.DocCur = '';
        this.DocDate = '';
        this.DocDueDate = '';
        this.DocEntry = '';
        this.DocNum = '';
        this.DocStatus = '';
        this.DocTotal = '';
        this.E_Mail = '';
        this.LicTradNum = '';
        this.PayToCode = '';
        this.ShipDirection = '';
        this.ShipToCode = '';
        this.VatSum = '';
        this.taxTotal = 0;
        this.Subtotal = 0;
    }
}

export class ItemLine {
    constructor() {
        this.ItemCode = '';
        this.Dscription = '';
        this.Quantity = '';
        this.Rate = 0;
        this.Price = 0;
        this.Total = 0;
        this.DiscountPercent = 0;
    }
}

export class EditableDoc {
    constructor() {
        this.shipToCode = '';
        this.addressType = '';
        this.street = '';
        this.block = '';
        this.city = '';
        this.zipCode = ''
    }
}

export class BankAccountRelationship {
    constructor() {
        this.idAPMBO = '';//autoincrement
        this.idPMBO = '';//idP paymentMethod
        this.namePayMethod = '';//name payment
        this.codePayMethod = '';//code payment
        this.AcctCode = ''; //acccode
        this.AcctName = '';//acct payment
        this.pk_Sucursal = '' //id Sucursal
        this.TipoUso = 3;
    }
}

export class PayMethodCounter {
    constructor() {
        this.Amount = 0;
        this.TypeMethod = '';
        this.PM_Name = '';
        this.PM_Code = '';
        this.idPMBO = '';
        // cash check
        this.PaycheckNum = '';
        this.DatePaycheck = moment(new Date()).format("YYYY-MM-DD");
        this.BankCode = '';
        this.BankName = '';
        this.PaymentAccountNum = '';
        // payment card debit or credit 
        this.CardNum = '';
        this.Indentification = '';
        this.PhoneNum = '';
        this.CreditCard = 0;
        this.CardValid = '';
        this.VoucherNum = '';
        //Transferencias
        this.TransferNum = '';
        this.PayAccountNum = '';
        //Devolution Return
        this.ReturnFolio = '';
        this.AvailableAmount = '';
        // DOWNPAYMENT 
        this.auxObjDP = {};

        this.DocEntryDP = '';
        this.AmountDP = 0;
        this.NumAtCardDP = '';
        //CREDITNOTES
        this.auxObjCN = {};

        this.DocEntryCN = '';
        this.AmountCN = 0;
        this.NumAtCardCN = '';
        this.U_UDF_UUID = '';
        this.FORMA_PAGO = '';

        // terminals info
        this.SuccessTerminal = false;

        //#region Flujo de caja
        this.CfwRlvnt = null;
        this.Finanse = null;
        this.transferCFWId = null; // Para transferencias
        this.needTransferCFW = false; // Para transferencias
        this.transferCFWOptions = []; // Para transferencias

        this.cashCFWId = null; // Para efectivo
        this.needCashCFW = false; // Para efectivo
        this.cashCFWOptions = []; // Para efectivo

        this.checkCFWId = null; // Para cheques
        this.needCheckCFW = false; // Para cheques
        this.checkCFWOptions = []; // Para cheques
        //#endregion Flujo de caja
    }
}

export class CashMovement {
    constructor() {
        this.cashAmount = '';
        this.comment = '';
        this.type = '';


    }
}

export class CounterPermissions {
    constructor() {
        this.EditPrice = false;
        this.EditDiscount = false;
    }
}
export class BranchPermission {
    constructor() {
        this.CloseDocuments = false;
        this.ProductionPrices = false;
        this.CancelClosePurchaseOrder = false;
        this.EditPurchaseOrder = false;
    }
}

export class BranchPermissions {
    constructor() {
        this.CloseDocuments = false;
        this.ProductionPrices = false;
        this.CancelClosePurchaseOrder = false;
        this.EditPurchaseOrder = false;
        this.ChangeTaxRate = false;
        this.PendingCashCut = false;
    }
}

export class CreditCards {
    constructor() {
        this.LineNum = 0;
        this.CardName = '';
        this.CreditCard = '';
        this.CreditAcct = '';
        this.CrCardNum = '';
        this.CardValid = '';
        this.VoucherNum = '';
        this.OwnerIdNum = '';
        this.OwnerPhone = '';
        this.CrTypeCode = '';
        this.NumOfPayments = '';
        this.FirstPaymentDue = '';
        this.FirstPaymentSum = '';
        this.AdditionalPaymentSum = '';
        this.CreditSum = '';
        this.CreditCur = '';
        this.CreditRate = '';
        this.ConfirmationNum = '';
        this.NumOfCreditPayments = '';
        this.CreditType = 'S';
        this.SplitPayments = '';
        this.isSelected = true;
        this.MaxValid = 0;
    }
}

export class DownPaymentToDraw {
    constructor() {
        this.DocEntry = 0;
        this.AmountToDraw = 0;
        this.DownPaymentType = "dptRequest";
        this.U_UDF_UUID = '';
        this.FORMA_PAGO = '';
    }
}

export class DocToPDFViewer {
    constructor() {
        this.Folio = '';
        this.TypeDoc = '';
        this.DocObjectType = 0;
        this.timbraResponse = {};
    }
}

export class NumeroLetra {
    Unidades = (num) => {

        switch (num) {
            case 1:
                return 'UN';
            case 2:
                return 'DOS';
            case 3:
                return 'TRES';
            case 4:
                return 'CUATRO';
            case 5:
                return 'CINCO';
            case 6:
                return 'SEIS';
            case 7:
                return 'SIETE';
            case 8:
                return 'OCHO';
            case 9:
                return 'NUEVE';
        }

        return '';
    }//Unidades()

    Decenas = (num) => {

        let decena = Math.floor(Number(num) / 10);
        let unidad = Number(num) - (decena * 10);

        switch (decena) {
            case 1:
                switch (unidad) {
                    case 0:
                        return 'DIEZ';
                    case 1:
                        return 'ONCE';
                    case 2:
                        return 'DOCE';
                    case 3:
                        return 'TRECE';
                    case 4:
                        return 'CATORCE';
                    case 5:
                        return 'QUINCE';
                    default:
                        return 'DIECI' + this.Unidades(unidad);
                }
            case 2:
                switch (unidad) {
                    case 0:
                        return 'VEINTE';
                    default:
                        return 'VEINTI' + this.Unidades(unidad);
                }
            case 3:
                return this.DecenasY('TREINTA', unidad);
            case 4:
                return this.DecenasY('CUARENTA', unidad);
            case 5:
                return this.DecenasY('CINCUENTA', unidad);
            case 6:
                return this.DecenasY('SESENTA', unidad);
            case 7:
                return this.DecenasY('SETENTA', unidad);
            case 8:
                return this.DecenasY('OCHENTA', unidad);
            case 9:
                return this.DecenasY('NOVENTA', unidad);
            case 0:
                return this.Unidades(unidad);
        }
    }//Unidades()

    DecenasY = (strSin, numUnidades) => {
        if (numUnidades > 0)
            return strSin + ' Y ' + this.Unidades(numUnidades)

        return strSin;
    }//DecenasY()

    Centenas = (num) => {
        let centenas = Math.floor(Number(num) / 100);
        let decenas = Number(num) - (centenas * 100);

        switch (centenas) {
            case 1:
                if (decenas > 0)
                    return 'CIENTO ' + this.Decenas(decenas);
                return 'CIEN';
            case 2:
                return 'DOSCIENTOS ' + this.Decenas(decenas);
            case 3:
                return 'TRESCIENTOS ' + this.Decenas(decenas);
            case 4:
                return 'CUATROCIENTOS ' + this.Decenas(decenas);
            case 5:
                return 'QUINIENTOS ' + this.Decenas(decenas);
            case 6:
                return 'SEISCIENTOS ' + this.Decenas(decenas);
            case 7:
                return 'SETECIENTOS ' + this.Decenas(decenas);
            case 8:
                return 'OCHOCIENTOS ' + this.Decenas(decenas);
            case 9:
                return 'NOVECIENTOS ' + this.Decenas(decenas);
        }

        return this.Decenas(decenas);
    }//Centenas()

    Seccion = (num, divisor, strSingular, strPlural) => {
        let cientos = Math.floor(Number(num) / divisor)
        let resto = Number(num) - (cientos * divisor)

        let letras = '';

        if (cientos > 0)
            if (cientos > 1)
                letras = this.Centenas(cientos) + ' ' + strPlural;
            else
                letras = strSingular;

        if (resto > 0)
            letras += '';

        return letras;
    }//Seccion()

    Miles = (num) => {
        let divisor = 1000;
        let cientos = Math.floor(Number(num) / divisor)
        let resto = Number(num) - (cientos * divisor)

        let strMiles = this.Seccion(num, divisor, 'UN MIL', 'MIL');
        let strCentenas = this.Centenas(resto);

        if (strMiles === '')
            return strCentenas;

        return strMiles + ' ' + strCentenas;
    }//Miles()

    Millones = (num) => {
        let divisor = 1000000;
        let cientos = Math.floor(Number(num) / divisor)
        let resto = Number(num) - (cientos * divisor)

        let strMillones = this.Seccion(Number(num), divisor, 'UN MILLON ', 'MILLONES ');
        let strMiles = this.Miles(resto);

        if (strMillones === '')
            return strMiles;

        return strMillones + ' ' + strMiles;
    }//Millones()

    NumeroALetras = (moneda, num,) => {

        let that = this;
        let monedaSingular = '';
        let monedaPlural = '';

        if (moneda === 'SOL') {
            monedaPlural = 'SOLES';
            monedaSingular = 'SOL';
        }

        if (moneda === 'USD') {
            monedaPlural = 'DOLARES';
            monedaSingular = 'DOLAR';
        }

        if (moneda === 'EUR') {
            monedaPlural = 'EUROS';
            monedaSingular = 'EURO';
        }

        if (moneda === 'CAD') {
            monedaPlural = 'DOLARES CANADIENSES';
            monedaSingular = 'DOLAR CANADIENSE';
        }

        let data = {
            numero: Number(num),
            enteros: Math.floor(Number(num)),
            centavos: (((Math.round(Number(num) * 100)) - (Math.floor(Number(num)) * 100))),
            letrasCentavos: '',
            letrasMonedaPlural: monedaPlural,//'SOLES', 'Dólares', 'Bolíletes', 'etcs'
            letrasMonedaSingular: monedaSingular, //'SOL', 'Dólar', 'Bolilet', 'etc'
            letrasMonedaCentavoPlural: '/100',
            letrasMonedaCentavoSingular: '/100'
        };

        // if (data.centavos > 0) {
        data.letrasCentavos = ' ' + (function () {
            if (data.centavos === 1)
                return that.Millones(0) + data.centavos + data.letrasMonedaCentavoSingular;
            else
                return that.Millones(0) + data.centavos + data.letrasMonedaCentavoPlural;
        })();
        // }
        ;

        if (data.enteros === 0)
            return 'CERO ' + data.letrasMonedaPlural + ' ' + data.letrasCentavos;
        if (data.enteros === 1)
            return this.Millones(data.enteros) + ' ' + data.letrasMonedaSingular + ' ' + data.letrasCentavos;
        else
            return this.Millones(data.enteros) + ' ' + data.letrasMonedaPlural + ' ' + data.letrasCentavos;

    }
}

export class ReportsModel {
    constructor() {
        this.CardCode = '';
        this.CardName = '';
        this.InitialDate = moment(new Date()).format('YYYY-MM-DD');
        this.FinalDate = moment(new Date()).format('YYYY-MM-DD');
        this.User = '---';
        this.UserName = '';
        this.Type = '---';
        this.checkViewEntries = false;
        this.checkBill = false;
        this.checkCashNotes = false;
        this.checkCreditNotes = false;
        this.checkRefounds = false;
        this.checkDirectDeliveries = false;
        this.checkReturn = false;
        this.checkCreditNote = false;

        this.WhsCode = '---';
        this.WhsName = '';
        this.Filter = '2';
        this.Departament = '---';
        this.Line = '---';
        this.checkExistDate = false;
        this.checkExistNegative = false;
        this.checkInformationBatch = false;
        this.checkExist = false;
        // purchasing docs
        this.supplierEntries = false;
        this.supplierInvoices = false;
        this.supplierReturns = false;
        this.supplierCreditNotes = false;
        this.supplierPayCondition = 0;

        this.ItemCode = '';
        this.ItemName = '';
        this.searchItem = '';
        this.checkActiveAmount = false;
        this.Amount = '';
        this.Condition = '<';
        this.PaymentType = '---';

        this.Sucursal = '---';
        this.SucursalName = '---';
        this.Status = '---';
    }
}

export class AuxiliarResponseModel {
    constructor() {
        this.ResponseName = '';
        this.ResponseMessage = '';
        this.ResponseStatus = '';
        this.Payment = '';


    }
}
export class TimbraDocModel {
    constructor() {
        this.DocEntry = '';
        this.TypeDoc = '';
        this.CardName = '';
        this.LicTradNum = '';
        this.ZipCode = '';
        this.U_FMB_REGIMEN_FISCAL = '';
        this.U_FMB_USO_CFDI = '';
        this.U_FMB_FORMA_PAGO = '';
        this.U_FMB_METODO_PAGO = '';
        this.U_FMB_AUX_CARDNAME = '';
    }
}

//#region MODELOS CARTA PORTE
export class ConceptoPorte {
    constructor() {
        this.Cantidad = '';
        this.ClaveUnidad = "ACT";
        this.Unidad = "Actividad";
        this.ShowUnidad = "ACT,Actividad,0"; // valor auxiliar para mostrar
        this.ClaveProdServ = "";
        this.Descripcion = "";
        this.ValorUnitario = "";
        this.ObjetoImp = "01";
        this.NoIdentificacion = "";

        this.Importe = 0.0;

        //valores que falta validar su valor real para XML 
        this.Descuento = 0.0;

        //estos la cague vana  nicerl cabecera
        this.IVA = 0.0;
        this.Retener = 0.0;
        this.RetenerISR = 0.0;
        this.idFMBConcept = '';

    }
}

export class UbicacionPorte {
    constructor() {
        this.update = 0;
        this.Codigo = 0;

        this.ShipToCode = '';

        // cartaporte20:Ubicaciones:Ubicación
        this.TipoUbicacion = '';
        this.IDUbicacion = '';
        this.RFCRemitenteDestinatario = '';
        this.NombreRemitenteDestinatario = '';
        this.NumRegIdTrib = '';
        this.ResidenciaFiscal = '';
        this.NumEstacion = '';
        this.NombreEstacion = '';
        this.NavegacionTrafico = '';
        this.FechaHoraSalidaLlegada = '';
        this.TipoEstacion = '';
        this.DistanciaRecorrida = 0.00;
        // cartaporte20:Ubicaciones:Ubicacion:Domicilio
        this.Calle = '';
        this.NumeroExterior = '';
        this.NumeroInterior = '';
        this.Colonia = '';
        this.Localidad = '';
        this.Referencia = '';
        this.Municipio = '';
        this.Estado = '';
        this.Pais = '';
        this.CodigoPostal = '';
    }
}

export class Mercancia {
    constructor() {
        this.update = 0;
        this.LineNum = '';
        this.ItemCode = '';
        this.Index = 0;
        this.claveProdServ = '';
        this.Code = 0;
        // cartaporte20:Mercancias:Mercancia
        this.BienesTransp = '';
        this.ClaveSTCC = '';
        this.Descripcion = '';
        this.Cantidad = 0;
        this.HomeQuantity = 0;
        this.ClaveUnidad = '';
        this.Unidad = '';
        this.Dimensiones = '';
        this.MaterialPeligroso = '';
        this.CveMaterialPeligroso = '';
        this.Embalaje = '';
        this.DescripEmbalaje = '';
        this.PesoEnKg = 0.00;
        this.ValorMercancia = 0.00;
        this.Moneda = '';
        this.FraccionArancelaria = '';
        this.UUIDComercioExt = '';

        // cartaporte20:Mercancias:Mercancia:Pedimentos
        this.Pedimentos = [{ Pedimento: '' }]; // (0, ilimitado) {Pedimento: ''}

        // cartaporte20:Mercancias:Mercancia:GuiasIdentificacion
        this.GuiasIdentificacion = [{ NumeroGuiaIdentificacion: '', DescripGuiaIdentificacion: '', PesoGuiaIdentificacion: '' }]; // (0, ilimitado)  

        // cartaporte20:Mercancias:Mercancia:CantidadTransporta
        this.CantidadTransporta = [{ Cantidad: '', IDOrigen: '', IDDestino: '', CvesTransporte: '' }]; // (0, ilimitado) 

        // cartaporte20:Mercancias:Mercancia:DetalleMercancia
        this.UnidadPesoMerc = '';
        this.PesoBruto = 0.00;
        this.PesoNeto = 0.00;
        this.PesoTara = 0.00;
        this.NumPiezas = 0;
    }
}
export class Autotransporte {
    constructor() {
        this.update = 0;
        this.CodigoAutotransporte = 0;

        // cartaporte20:Mercancias:Autotransporte
        this.PermSCT = '';
        this.NumPermisoSCT = '';
        // cartaporte20:Mercancias:Autotransporte:IdentificacionVehicular
        this.ConfigVehicular = '';
        this.PlacaVM = '';
        this.AnioModeloVM = '';
        // cartaporte20:Mercancias:Autotransporte:Seguros
        this.AseguraRespCivil = '';
        this.PolizaRespCivil = '';
        this.AseguraMedAmbiente = '';
        this.PolizaMedAmbiente = '';
        this.AseguraCarga = '';
        this.PolizaCarga = '';
        this.PrimaSeguro = 0;
        // cartaporte20:Mercancias:Autotransporte:Remolques
        this.Remolques = [{ SubTipoRem: '', Placa: '' }]; // (1, 2)
        this.CodigoUnidad = '';
        this.TipodeUnidad = '';
        // NUEVO 30
        this.PesoBrutoVehicular = '';
        this.U_FMB_Sucursal = "";
        this.SupportWeight = 0.0;
        this.U_FMB_ValidateSeriesSUNAT = {};
        // codigo de Ubicaciones de SAP
        this.U_AbsEntry = '';

        this.searchItem = '';
        this.Items = [];
        this.roadMap = 'N'
    }
}

export class TransporteAereo {
    constructor() {
        this.update = 0;
        this.CodigoTransporteAereo = 0;

        // cartaporte20:Mercancias:TransporteAereo
        this.PermSCT = '';
        this.NumPermisoSCT = '';
        this.MatriculaAeronave = '';
        this.NombreAseg = '';
        this.NumPolizaSeguro = '';
        this.NumeroGuia = '';
        this.LugarContrato = '';
        this.CodigoTransportista = '';
        this.RFCEmbarcador = '';
        this.NumRegIdTribEmbarc = '';
        this.ResidenciaFiscalEmbarc = '';
        this.NombreEmbarcador = '';
    }
}

export class TransporteFerroviario {
    constructor() {
        this.update = 0;
        this.CodigoTransporteFerroviario = 0;

        // cartaporte20:Mercancias:TransporteFerroviario
        this.TipoDeServicio = '';
        this.TipoDeTrafico = '';
        this.NombreAseg = '';
        this.NumPolizaSeguro = '';
        // cartaporte20:Mercancias:TransporteFerroviario:DerechosDePaso
        this.DerechosDePaso = [{ TipoDerechoDePaso: '', KilometrajePagado: 0 }]; // (0, ilimitado) 

        // cartaporte20:Mercancias:TransporteFerroviario:Carro
        this.Carro = [{
            TipoCarro: '',
            MatriculaCarro: '',
            GuiaCarro: '',
            ToneladasNetasCarro: '',
            // cartaporte20:Mercancias:TransporteFerroviario:Carro:Contenedor
            // Contenedor: [{ TipoContenedor: '', PesoContenedorVacio: '', PesoNetoMercancia: ''}] // (0, ilimitado) 
        }]; // (1, ilimitado);
        // cartaporte20:Mercancias:TransporteFerroviario:Carro:Contenedor
        this.Contenedor = [{ TipoContenedor: '', PesoContenedorVacio: '', PesoNetoMercancia: '' }] // (0, ilimitado) 
    }
}

export class TransporteMaritimo {
    constructor() {
        this.update = 0;
        this.CodigoTransporteMaritimo = 0;

        // cartaporte20:Mercancias:TransporteMaritimo
        this.PermSCT = '';
        this.NumPermisoSCT = '';
        this.NombreAseg = '';
        this.NumPolizaSeguro = '';
        this.TipoEmbarcacion = '';
        this.Matricula = '';
        this.NumeroOMI = '';
        this.AnioEmbarcacion = '';
        this.NombreEmbarc = '';
        this.NacionalidadEmbarc = '';
        this.UnidadesDeArqBruto = '';
        this.TipoCarga = '';
        this.NumCertITC = '';
        this.Eslora = '';
        this.Manga = '';
        this.Calado = '';
        this.LineaNaviera = '';
        this.NombreAgenteNaviero = '';
        this.NumAutorizacionNaviero = '';
        this.NumViaje = '';
        this.NumConocEmbarc = '';
        // cartaporte20:Mercancias:TransporteMaritimo:Contenedor
        this.Contenedor = [{ MatriculaContenedor: '', TipoContenedor: '', NumPrecinto: '' }]; // (1, ilimitado) 

    }
}

export class ItemsTransporte {
    constructor() {
        this.ItemCode = '';
        this.ItemName = '';
        this.Capital = 0;
        this.isNew = false;
    }
}

export class TiposFigura {
    constructor() {
        this.update = 0;
        this.CodigoFiguraTransporte = 0;

        // cartaporte20:FiguraTransporte:TiposFigura
        this.TipoFigura = '';
        this.RFC = '';
        this.NombreFigura = '';
        this.NumLicencia = '';
        this.NumRegIdTrib = '';
        this.ResidenciaFiscalFigura = '';
        // cartaporte20:FiguraTransporte:TiposFigura:PartesTransporte
        this.PartesTransporte = [{ ParteTransporte: '' }]; // (0, ilimitado) 
        // cartaporte20:FiguraTransporte:TiposFigura:Domicilio
        this.Calle = '';
        this.NumeroExterior = '';
        this.NumeroInterior = '';
        this.Colonia = '';
        this.Localidad = '';
        this.Referencia = '';
        this.Municipio = '';
        this.Estado = '';
        this.Pais = '';
        this.CodigoPostal = '';
        this.CodigoPostal = '';
        this.Email = '';
        this.Password = '';
        this.U_FMB_Sucursal = '';
        this.IdVHCL = '-1';

    }
}

export class CartaPorte {
    constructor() {
        this.TypeDoc = 'I';
        this.SubTypeTransferDoc = 'S'
        this.update = 0;
        this.CodigoCarta = 0;
        this.CardCode = "";
        this.CardName = "";
        this.DocEntry = "";
        this.DocNum = "";
        this.UsoCFDI = '';
        this.SerieCode = '';
        this.SerieName = '';

        // cartaporte20:CartaPorte
        // this.Version = '2.0';
        this.Version = '3.1';
        this.TranspInternac = 'No';
        this.EntradaSalidaMerc = '';
        this.PaisOrigenDestino = '';
        this.ViaEntradaSalida = '';
        this.TotalDistRec = 0.00;

        // cartaporte20:Ubicaciones
        // this.Ubicaciones = [new UbicacionPorte(), new UbicacionPorte()]; // (2, ilimitado) 
        this.Ubicaciones = []; // (2, ilimitado) 

        // cartaporte20:Mercancias
        this.PesoBrutoTotal = 0.00;
        this.UnidadPeso = 'KGM';
        this.PesoNetoTotal = 0.00;
        this.NumTotalMercancias = 0.00;
        this.CargoPorTasacion = 0.00;

        // cartaporte20:Mercancias:Mercancia
        this.Mercancias = []; // (1, ilimitado) new Mercancia();

        // // cartaporte20:Mercancias:Autotransporte
        // this.Autotransporte = new Autotransporte();
        // // cartaporte20:Mercancias:TransporteMaritimo
        // this.TransporteMaritimo = new TransporteMaritimo();
        // // cartaporte20:Mercancias:TransporteAereo
        // this.TransporteAereo = new TransporteAereo();
        // // cartaporte20:Mercancias:TransporteFerroviario
        // this.TransporteFerroviario = new TransporteFerroviario();

        this.Transporte = '';
        this.TipoTransporte = '';
        this.U_FMB_UUID = '';

        // cartaporte20:FiguraTransporte
        // this.FiguraTransporte = [new TiposFigura()]; // (1, ilimitado) new TiposFigura();
        this.FiguraTransporte = '';


        // CONCEPTOS 
        this.Concepts = [];
        // CFDI RELACIONADOS Y MOTIVO
        this.MotivoRelacion = '00';
        this.CFDI_Relacionados = [];

        // valores auxiliares
        this.Catalogo_USO_CFDI = [];
        this.ArrayDocEntriesInv = [];

        // nuevo valores 3.0 cabecera

        this.IdCCP = '';
        this.TranspInternac = 'No';
        this.CanceledCFDI = 'N';
        this.xml_Process = '';

        // Configración de remolques
        this.ConfRemolques = [];

        // Carta Porte de Uso Interno
        this.UsoInterno = 'N';
        this.CardName = '';
        this.LicTradNum = '';
        this.ZipCode = '';
        this.GroupNum = '';
        this.U_FMB_REGIMEN_FISCAL = '';
        this.U_FMB_METODO_PAGO = 'PUE';
        this.U_FMB_FORMA_PAGO = '01';
        this.Currency = 'SOL';

        this.TotalFlete = 0.0;
    }
}

//#endregion


export class PaymentInfoMIT {
    // this comments its example info
    constructor() {
        this.nu_operaion = "";
        this.cd_usuario = "";
        this.cd_empresa = "";

        this.nu_sucursal = "";
        this.nu_afiliacion = "";
        this.nb_referencia = "";

        this.cc_nombre = "";
        this.cc_num = "";
        this.cc_tp = "";

        this.nu_importe = "";
        this.cd_tipopago = "";
        this.cd_tipocobro = "";

        this.cd_instrumento = "";
        this.nb_response = "";
        this.nu_auth = "";

        this.fh_registro = "";
        this.fh_bank = "";
        this.cd_usrtransaccion = "";

        this.tp_operacion = "";
        this.nb_currency = "";
        this.cd_resp = "";

        this.nb_resp = "";
    }
}


//#region M-SUITE
//--- sellers admin
export class DocsLineRouteDelivery {
    constructor() {
        this.IdRDL1 = '';
        this.DocEntry = '';
        this.DocNum = '';
        this.CardCode = ''
        this.CardName = '';
        this.U_FMB_GPSLatS = 0;
        this.U_FMB_GPSLonS = 0;
        this.DocTotal = '';
        this.Weight = '';
        this.IdORDL = '';
        this.Comments = '';
        this.NewDocEntry = '';
        this.TypeDoc = '';
        this.DocStatus = '';

        this.InitVisitDateTime = '';
        this.FinalVisitDateTime = '';
        // --------------------------

        this.Quantity = 0.0;
        this.ItemName = "";
        this.LineTotal = 0.0;
        this.TotalWeightLine = 0.0;
        this.ObjType = -1;
        this.NumAtCard = "";
        this.LineByBot = false;
        this.LineNum = "";
        this.ShipToCode = "";
        this.Address = "";
        this.ProcessStatus = "";

        this.Priority = 0;
        this.ColorPriority = '';
    }
}

export class RouteDocSellers {
    constructor() {
        // cabecera
        this.Code = '';
        this.Name = '';
        this.SlpCode = '';
        this.Comment = '';
        this.IsActive = false;
        this.IdCreator = '';
        this.IdUpdateCreator = '';
        this.CreatedTime = moment().format('LT');

        this.DocDate = moment(new Date()).format('YYYY-MM-DD');
        this.UpdateDate = '';
        this.InitialDate = moment(new Date()).format('YYYY-MM-DD');
        this.CreatedDate = moment(new Date()).format('YYYY-MM-DD');
        this.RoutesLines = [];
        this.DocStatus = '';
        this.IdRegister = '';
    }
}

export class SellerRouteEvent {
    constructor() {
        this.Id = '';
        this.Title = '';
        this.DateStart = '';
        this.DateEnd = '';
        this.Color = "#000000";
        this.CreatedDate = moment(new Date()).format('YYYY-MM-DD');
        this.RouteCode = '';
        this.IdEVRO = '';
    }
}

export class SellerRouteLine {
    constructor() {
        this.RouteCode = '';
        this.LineNum = '';
        this.GroupRoute = '';
        this.CardCode = '';
        this.Comments = '';
        this.AddressType = 'S';
        this.Address = '';
        this.DocDate = moment().format('YYYY-MM-DD');
        this.UpdateDate = '';
        this.U_FMB_GPSLat = 0;
        this.U_FMB_GPSLon = 0;
        this.Order = '';
        this.Visited = 0;
    }
}

// admin deliveries

export class RouteDocDelivery {
    constructor() {
        this.IdORDL = '';
        this.Code = '';
        this.Name = '';
        this.IdVDRV = ''; //unique code for driver
        this.NameDriver = '';
        this.IdVHCL = ''; // unique code for vehicle
        this.CodigoAutotransporte = ''; //unique code for vehicle new version with CP
        this.Description = '';
        this.DocStatus = 'O';
        this.InitialDate = moment(new Date()).format('YYYY-MM-DD');
        this.FinalDate = moment(new Date()).format('YYYY-MM-DD');
        this.DocDate = moment(new Date()).format('YYYY-MM-DD');
        this.UpdateDate = '';
        this.CreatedTime = moment().format('LT');
        this.UpdateTime = '';
        this.IdCreator = '';
        this.IdUpdateCreator = '';
        this.DocsLines = [];
        this.IsActive = false;
        this.driverPhone = '';
        this.email = '';
        // vehicle info
        this.vehicleBrand = '';
        this.vehiclePlate = '';
        this.AuxIndexDriver = '';
        this.tipodeUnidad = '';

        // r2d2 integration
        this.IdRoute = '';
        this.IA_Lines = [];
        this.NumMerch = 0;
        this.WeightCharged = 0.0;
        this.IdRTDOC = -1;

        this.TransferRoute = null;
        this.AttentionType = '';
        this.Status = 0;

    }
}


export class Driver {
    constructor() {
        this.IdVDRV = '';
        this.Code = '';
        this.TypeDRV = '01';
        this.Name = '';
        this.RFC = '';
        this.NumLicense = '';

        this.Phone = '';
        this.Email = '';
        this.IsActive = '';

        this.AddressId = '';
        this.AddressCP = '';
        this.AddressCounty = '';
        this.AddressCity = '';
        this.AddressBlock = '';
        this.AddressStreet = '';

        this.Password = '';
    }
}

export class Vehicle {
    constructor() {
        this.IdVHCL = '';
        this.Brand = '';//marca

        this.Year = '';
        this.Color = '';
        this.MaxWeightTons = 0;

        this.Plate = '';
        this.Trailer = '';
        this.IsActive = '';

    }
}

//----- authorize partner model 

export class AuthorizePartnerModel {
    constructor() {
        this.CardCode = '';
        this.CardName = '';
        this.Email = '';
        this.Phone = '';
        this.LicTadNum = '';
        this.OriginShipDirection = new Addresses();
        this.NewShipDirection = new Addresses();
        this.OrigiBillDirection = new Addresses();
        this.NewBillDirection = new Addresses();
    }
}




//#endregion


//#region ################## POINTS CARD ################ ✔

export class NewCustomer {
    constructor() {
        let today = moment(new Date()).format('YYYY-MM-DD');

        this.customer_id = '';
        this.CardCode = '';
        this.CardName = '';
        this.DocEntry = '';
        this.E_Mail = '';
        this.U_FMB_Handel_Email = '';
        this.U_FMB_Cellular = '';
        this.U_FMB_Handel_Pass = '';
        this.pointsCard = '';
        this.registration_Date = '';
        this.totalPoints = '';
    }
}

export class PointsCardModel {
    constructor() {
        this.Point_Value = 0;
        this.last_reset_date = '';
        this.InvoiceCredit = 'N';
        this.reset = false;
        // DEFINICIONES
        this.Definitions = [new Definitions()];
        // CUSTOMER
        this.Customer = new NewCustomer();
    }
}

export class Definitions {
    constructor() {
        this.OpenDate = moment(new Date()).format('YYYY-MM-DD');
        this.CloseDate = moment(new Date()).format('YYYY-MM-DD');

        this.isNew = true;
        this.level_id = '';
        this.name = '';
        this.discount_percentage = '';
        this.MinAmount = '';
        this.MaxAmount = '';
        this.PerAmount = '';
        this.Points = 1;
        this.RegularProfit = '16.00';
        this.SpecialProfit = 5.00;
        this.PerSpecial = '';
    }
}
//#endregion


//#region MRP
export class Forecast {
    constructor() {
        this.AbsID = -1;
        this.ForecastStartDate = moment().format("YYYY-MM-DD");
        this.ForecastEndDate = moment().format("YYYY-MM-DD");
        this.ForecastCode = "";
        this.ForecastName = "";
        this.View = "M"; // M - Mensual, W - Semanal, D - Diario
        this.SalesForecastLines = [];

        //#region Variables de control
        this.TimeInterval = [];
        this.PrevStartDate = moment().format("YYYY-MM-DD");
        this.PrevEndDate = moment().format("YYYY-MM-DD");
        //#endregion
    }
}

export class MRPAssistant {
    constructor() {
        // Detalles del escenario
        this.AbsEntry = 0;
        this.DocEntry = 0;
        this.MsnCode = "";
        this.Descr = "";
        this.StartDate = moment().format("YYYY-MM-DD");
        this.EndDate = moment().format("YYYY-MM-DD");
        this.PeriodsLen = 1;
        this.GrpPeriods = "D";
        this.HorizonLength = 1;
        this.HldaysProd = "Y";
        this.HldaysPurc = "Y";
        this.IgnoreCLT = "N";
        this.SortBy = "L";
        this.ItmReq = "N";
        this.DisSelItem = "N";
        this.Simulation = "N";

        // Artículos
        this.AllItems = "Y";
        this.ItmArray = [];

        // Almacenes
        this.ByCompany = "Y";
        this.WhsArray = [];

        // Documentos
        this.IncHisData = "N";

        this.PurchReq = "N";
        this.PurchQuota = "N";
        this.PurchOrder = "N";
        this.PurchOAT = "N";
        this.SalesQuota = "N";
        this.SalesOrder = "N";
        this.SalesOAT = "N";
        this.WorkOrder = "N";
        this.Wtrq = "N";
        this.ResInv = "N";
        this.Rots = "N";

        this.ExpdPurReq = "N";
        this.ExpdPQuota = "N";
        this.ExpandedPO = "N";
        this.ExpdPAgree = "N";
        this.ExpdSQuota = "N";
        this.ExpandedSO = "N";
        this.ExpdSAgree = "N";
        this.ExpdWOR = "N";
        this.ExpdTraReq = "N";
        this.ExpdResINV = "N";

        this.InvtLevel = "D";
        this.FCTAbs = 1;
        this.RcmPO = "N";
        this.RcmWO = "N";
        this.RcmWTRQ = "N";
        this.RCMDefWhs = "N";

        // V2
        this.ForecastArray = [];
        this.itmsGrpCod = "";

        // Variables de control
        this.WhsChecks = {
            ReqSel: true,
            InvtSel: true,
            ExtIvntSel: true,
        };
        this.TimeInterval = [];
        this.Documents = [];
        this.RcmLines = [];
        this.Lines = [];
        this.RcmCalDate = null;
        this.RcmCalTime = null;
        this.showMRPResults = true;
    }
}

export class ForecastLine {
    constructor() {
        this.ItemNo = "";
        this.ItemDescription = "";
        this.Warehouse = "";
        this.TimeInterval = [];

        //#region Variables de control
        this.NewLine = true;
        //#endregion
    }
}

export class ForecastTimeInterval {
    constructor() {
        this.Name = "";
        this.ForecastedDay = moment().format("YYYY-MM-DD");
        this.Quantity = "0.000";
    }
}

//#endregion
export class LandedCosts {
    constructor() {
        this.Ref1 = '';
        this.AgentNum = '';
        this.CustDate = moment(new Date()).format('YYYY-MM-DD');
        this.IncCustom = true;
        this.ActCustom = "0.00";
        this.ExpCustom = "0.00";
        this.CostSum = "0.00";
        this.BeforeVat = 0;
        this.Vat1 = "0.00";
        this.Vat2 = "0.00";
        this.deliveryPrices = [];
        this.prevValues = [];
    }
}
//#endregion


//#region ################## PRODUCCION ################ ✔
export class ProductTree {
    constructor() {
        this.TreeCode = "";
        this.Desc = "";
        this.TreeType = "T";
        this.Quantity = "1";
        this.Project = "";
        this.PriceList = "";
        this.Warehouse = "";
        this.ProductTreeLines = []//ProductTreeLines;
    }
}
export class ProductTreeLine {
    constructor() {
        this.ItemCode = "";
        this.Quantity = "";
        this.Warehouse = "";
        this.Price = "";
        this.Currency = "";
        this.IssueMethod = "";
        this.InventoryUOM = "";
        this.Comment = "";
        this.ParentItem = "";
        this.PriceList = "";
        this.ItemType = "";
        this.OcrCode = '';
        this.OcrCode2 = '';
        this.OcrCode3 = '';
        this.OcrCode4 = '';
        this.OcrCode5 = '';

        //#region DIMENSIONS
        this.Dimension1 = false;
        this.Dimension2 = false;
        this.Dimension3 = false;
        this.Dimension4 = false;
        this.Dimension5 = false;
        //#endregion DIMENSIONS
    }
}

export class ProductionOrder {
    constructor() {
        this.AbsoluteEntry = "";
        this.DocumentNumber = "";
        this.Series = "";
        this.ItemNo = "";
        this.ItemCode = "";
        this.ProductionOrderStatus = "P";
        this.CurrentStatus = "P";
        this.OnlyView = false; // Bandera para indicar solo lectura
        this.ProductionOrderType = "S";
        this.PlannedQuantity = "1";
        this.CompletedQuantity = "";
        this.RejectedQuantity = "";
        this.PostingDate = moment(new Date()).format('YYYY-MM-DD');
        this.DueDate = moment(new Date()).format('YYYY-MM-DD');
        this.ProductionOrderOriginEntry = "";
        this.ProductionOrderOriginNumber = "";
        this.ProductionOrderOrigin = "M";
        this.UserSignature = "";
        this.Remarks = "";
        this.ClosingDate = "";
        this.ReleaseDate = "";
        this.CustomerCode = "";
        this.Warehouse = "";
        this.WhsName = "";
        this.InventoryUOM = "";
        this.JournalRemarks = "";
        this.TransactionNumber = "";
        this.CreationDate = "";
        this.Printed = "";
        this.DistributionRule = "";
        this.Project = "";
        this.DistributionRule2 = "";
        this.DistributionRule3 = "";
        this.DistributionRule4 = "";
        this.DistributionRule5 = "";
        this.UoMEntry = "";
        this.StartDate = moment(new Date()).format('YYYY-MM-DD');
        this.U_SO1_01FOLIORETAIL1 = "";
        this.ProductionOrderLines = [];
        this.ProductionOrdersSalesOrderLines = [];//ProductionLine

        // MARIN COPY TO
        this.FlagCreateGoodIssue = false;
        this.FlagCreateGoodsReceiptProd = false;
        this.DocumentView = '';
        this.DocNum = '';
        this.DocEntry = '';
        this.totalReceived = 0;

        this.Uom = '';
        this.RelatedDocs = [];
        //#region CUFD
        this.U_RS_CANT = 0;
        //#endregion CUFD
    }
}
export class ProductionLine {
    constructor() {
        this.DocumentAbsoluteEntry = "";
        this.LineNumber = "";
        this.ItemNo = "";
        this.BaseQuantity = "";
        this.BaseQuantityCopy = "";
        this.PlannedQuantity = "";
        this.IssuedQuantity = "";
        this.ProductionOrderIssueType = "im_Manual";
        this.Warehouse = "";
        this.VisualOrder = "";
        this.DistributionRule = "";
        this.LocationCode = "";
        this.Project = "";
        this.DistributionRule2 = "";
        this.DistributionRule3 = "";
        this.DistributionRule4 = "";
        this.DistributionRule5 = "";
        this.UoMEntry = "";
        this.UoMCode = "";
        this.WipAccount = "";
        this.ItemType = "pit_Item";
        this.LineText = "";
        this.AdditionalQuantity = "";
        this.ResourceAllocation = "";
        this.StartDate = "";
        this.EndDate = "";
        this.SerialNumbers = "";
        this.BatchNumbers = "";

        this.Uom = "";
        this.Available = "";
        this.isStatic = null;
        this.WhsCode = '';
        this.WhsName = '';
        this.unitMsr = '';
        this.OcrCode = '';
        this.OcrCode2 = '';
        this.OcrCode3 = '';
        this.OcrCode4 = '';
        this.OcrCode5 = '';

        //#region DIMENSIONS
        this.Dimension1 = false;
        this.Dimension2 = false;
        this.Dimension3 = false;
        this.Dimension4 = false;
        this.Dimension5 = false;
        //#endregion DIMENSIONS
    }
}

export class InventoryGenExits {
    constructor() {
        this.DocStatus = "";
        this.DocEntry = "";
        this.DocNum = "";
        this.DocDueDate = ""; //TaxDate
        this.DocDate = moment(new Date()).format('YYYY-MM-DD');;
        this.JournalMemo = ""
        this.Series = ""
        this.SerieName = ""
        this.Reference2 = '';
        this.Comments = ""
        this.DocumentLines = [];

    }
}

export class InventoryGenExitsLine {
    constructor() {

        this.DocEntry = "";
        this.LineNum = "";
        this.ItemCode = "";
        this.ItemDescription = "";
        this.WarehouseCode = "";
        this.AccountCode = "";

        this.Quantity = 0;
        this.OpenQty = 0;
        this.LineStatus = "";
        this.BaseType = -1;
        this.BaseEntry = null;
        this.BaseLine = null;
        this.Price = 0.0;

        this.TargetType = "";
        this.BaseRef = "";
        this.LineTotal = "";
        this.ObjType = "";

        this.ItemType = 4;
        this.SeriesName = '';
        this.Series = '';
        this.PlannedQty = '';
        this.WhsCode = '';
        this.WhsName = '';
        this.unitMsr = '';
        this.OcrCode = '';
        this.OcrCode2 = '';
        this.OcrCode3 = '';
        this.OcrCode4 = '';
        this.OcrCode5 = '';

        //#region DIMENSIONS
        this.Dimension1 = false;
        this.Dimension2 = false;
        this.Dimension3 = false;
        this.Dimension4 = false;
        this.Dimension5 = false;
        //#endregion DIMENSIONS
    }
}

export class InventoryGenEntries {
    constructor() {
        this.DocStatus = "";
        this.DocEntry = "";
        this.DocNum = "";
        this.DocDueDate = ""; //TaxDate
        this.DocDate = moment(new Date()).format('YYYY-MM-DD');;
        this.JournalMemo = ""
        this.Series = ""
        this.SeriesName = ""
        this.Reference2 = '';
        this.Comments = ""
        this.DocumentLines = [];
        this.WhsCode = '';
        this.WhsName = '';
        this.unitMsr = '';

    }
}

export class InventoryGenEntriesLine {
    constructor() {

        this.DocEntry = "";
        this.LineNum = "";
        this.ItemCode = "";
        this.ItemDescription = "";
        this.WarehouseCode = "";
        this.AccountCode = "";

        this.Quantity = 0;
        this.OpenQty = 0;
        this.LineStatus = "";
        this.BaseType = -1;
        this.BaseEntry = null;
        this.BaseLine = null;
        this.Price = 0.0;

        this.TargetType = "";
        this.BaseRef = "";
        this.LineTotal = "";
        this.ObjType = "";

        this.ItemType = 4;
        this.SeriesName = '';
        this.Series = '';
        this.PlannedQty = '';
        this.TranType = '';
        this.WhsCode = '';
        this.WhsName = '';
        this.unitMsr = '';
        this.OcrCode = '';
        this.OcrCode2 = '';
        this.OcrCode3 = '';
        this.OcrCode4 = '';
        this.OcrCode5 = '';

        //#region DIMENSIONS
        this.Dimension1 = false;
        this.Dimension2 = false;
        this.Dimension3 = false;
        this.Dimension4 = false;
        this.Dimension5 = false;
        //#endregion DIMENSIONS
    }
}

export class ProvConfAsisstant {
    constructor() {
        this.CustomerCode = '';
        this.CustomerCode2 = '';
        this.SupplierCode = '';
        this.PartnerGroups = [];
        this.PartnerGroup = -1;
        this.AllPartners = false;
        this.PartnerProperties = [];
    }
}
//#endregion ################## PRODUCCION ################ ✔

//#region    ################## RECURSOS ################ ✔
export class ResourceModel {
    constructor() {
        this.Code = "";
        this.VisCode = "";
        this.CodeBar = "";
        this.Name = "";
        this.ForeignName = "";
        this.Type = "M"; // Valid values: 'rtMachine'-'M', 'rtLabor'-'L', 'rtOther'-'O'
        this.Group = 1;
        this.UnitOfMeasure = null;
        this.TimePerUnits = null;
        this.UnitsPerTime = 1;
        this.IssueMethod = "B"; // Valid values; 'rimBackflush'-'B', 'rimManual'-'M'
        this.Allocation = "S"; // Valid values: 'raOnStartDate'-'S', 'raOnEndDate'-'D', 'raStartDateForwards'-'F', 'raEndDateBackwards'-'B'
        this.Active = "Y";
        this.ActiveFrom = null;
        this.ActiveTo = null;
        this.ActiveRemarks = "";
        this.Inactive = "N";
        this.InactiveFrom = null;
        this.InactiveTo = null;
        this.InactiveRemarks = "";
        this.Costs = new Array(10).fill("0.00");
        this.ResourceDailyCapacities = Array.from({ length: 7 }, (v, i) => ({
            Weekday: i + 1,
            Factor1: null,
            Factor2: null,
            Factor3: null,
            Factor4: null,
            Total: null,
            Remarks: ""
        }));
        this.Properties = [];
        this.ResourceWarehouses = [];
        this.ResourceFixedAssets = [];
        this.ResourceEmployees = [];
    }
}
//#endregion ################## RECURSOS ################ ✔

// #region    ################## REFERRED SYSTEM ################ ✔
export class PartnerAmbassador {
    constructor() {
        this.update = 0;
        this.CardCode = '';
        this.CardType = 'C';
        this.Balance = 0;
        this.DocCur = '';
        this.DNotesBal = 0;
        this.OrdersBal = 0;
        this.validFor = 'Y';
        this.CardTypeName = 'Cliente';
        this.CardName = '';
        this.GroupCode = '';
        this.GroupCodeName = '';
        this.Currency = 'SOL';
        this.CurrencyName = 'SOL';
        this.LicTradNum = '';
        this.Phone1 = '';
        this.Phone2 = '';
        this.E_mail = '';
        this.SlpCode = '-1';
        this.SlpName = 'SIN ASIGNAR';
        this.GroupNum = '';
        this.GroupNumName = '';
        this.PriceListNum = '';
        this.PriceListNumName = '';
        this.CreditLine = '';
        this.DebtLine = '';
        this.Territory = '';
        this.TerritoryName = '';
        this.CntctPrsn = '';
        this.CntctPrsnName = '';
        this.ShipToDef = '';
        this.BillToDef = '';
        this.deliveriesAddressEditIndex = null;
        this.invoicesAddressEditIndex = null;
        this.contactEditIndex = null;
        this.DeliveriesAddress = [];
        this.InvoicesAddress = [];
        this.ContactPersons = [];
        this.PayMethodCodes = [];
        this.PymCode = '';
        this.RefDetails = '';
        this.PymCodeName = '';
        this.userFields = new UserFields();
        this.BankAccounts = [];
        this.ChangeGroupNum = false;  //bandera para poder remplazar balores de la condicion de pago

        //Impuesto Finanzas
        this.WTLiable = false;
        this.VatStatus = '';
        this.TaxCode = '';
        this.TaxName = '';
        this.FatherType = '';
        this.DebPayAcct = '';
        this.DebPayAcctName = '';

        this.DefaultBankCode = '';
        this.BankCountr = '';
        this.BankCode = '';
        this.DflAccount = '';
        this.DflSwift = '';
        this.DflBranch = '';
        this.BankCtlKey = '';
        this.DflIBAN = '';

        // FILDS TO DOWN PAYMENTS
        this.DownPaymentClearAct = '';
        this.DownPaymentInterimAccount = '';

        this.U_FMB_AMBASSADOR = 'Y'

        this.U_FMB_EMAIL_AMBASSADOR = '';
        this.U_FMB_PASS_AMBASSADOR = '';
    }
}

export class PartnerReferred {
    constructor() {
        this.update = 0;
        this.CardCode = '';
        this.CardType = 'C';
        this.Balance = 0;
        this.DocCur = '';
        this.DNotesBal = 0;
        this.OrdersBal = 0;
        this.validFor = 'Y';
        this.CardTypeName = 'Cliente';
        this.CardName = '';
        this.GroupCode = '';
        this.GroupCodeName = '';
        this.Currency = 'SOL';
        this.CurrencyName = 'SOL';
        this.LicTradNum = '';
        this.Phone1 = '';
        this.Phone2 = '';
        this.E_mail = '';
        this.SlpCode = '-1';
        this.SlpName = 'SIN ASIGNAR';
        this.GroupNum = '';
        this.GroupNumName = '';
        this.PriceListNum = '';
        this.PriceListNumName = '';
        this.CreditLine = '';
        this.DebtLine = '';
        this.Territory = '';
        this.TerritoryName = '';
        this.CntctPrsn = '';
        this.CntctPrsnName = '';
        this.ShipToDef = '';
        this.BillToDef = '';
        this.deliveriesAddressEditIndex = null;
        this.invoicesAddressEditIndex = null;
        this.contactEditIndex = null;
        this.DeliveriesAddress = [];
        this.InvoicesAddress = [];
        this.ContactPersons = [];
        this.PayMethodCodes = [];
        this.PymCode = '';
        this.RefDetails = '';
        this.PymCodeName = '';
        this.userFields = new UserFields();
        this.BankAccounts = [];
        this.ChangeGroupNum = false;  //bandera para poder remplazar balores de la condicion de pago

        //Impuesto Finanzas
        this.WTLiable = false;
        this.VatStatus = '';
        this.TaxCode = '';
        this.TaxName = '';
        this.FatherType = '';
        this.DebPayAcct = '';
        this.DebPayAcctName = '';

        this.DefaultBankCode = '';
        this.BankCountr = '';
        this.BankCode = '';
        this.DflAccount = '';
        this.DflSwift = '';
        this.DflBranch = '';
        this.BankCtlKey = '';
        this.DflIBAN = '';

        // FILDS TO DOWN PAYMENTS
        this.DownPaymentClearAct = '';
        this.DownPaymentInterimAccount = '';

        this.U_FMB_AMBASSADOR = 'N'
        this.U_FMB_RELATED_AMBASSADOR = '';

    }
}

//#endregion ################## REFERRED SYSTEM ################ ✔

// #region    ################## SUGGEST REFILL DOCUMENTS ################ ✔
export class SuggestRefillDocument {
    constructor() {
        let today = moment(new Date()).format('YYYY-MM-DD');

        this.OriginDocumentCreate = "suggestRefill";
        this.DocType = "I";
        this.DocumentType = "F";
        this.WddStatus = "";
        this.isDocumentWithAuthorization = false;
        this.DocStatus = "";
        this.DocEntry = "";
        this.DocEntryRel = "";
        this.CardCode = "";
        this.Balance = "";
        this.DocNum = "";
        this.UserID = 0;
        this.CreditLine = "";
        this.CardName = "";
        this.Address = "";
        this.ShipToCode = "";
        this.Address2 = "";
        this.GroupCode = '';
        this.PriceListNum = "";
        this.NextFolio = "";
        this.StatusDocument = "";
        this.NumAtCard = "";
        this.RecoverIdSale = '';
        this.DocCur = "SOL";
        this.SpecialProce = [];
        this.Currencies = [];
        this.DocCurDocumentsPayment = "";
        this.ChangeRate = 1;
        this.SerieName = "";
        this.SerieCode = null;
        this.SerieArray = [];
        this.DocDate = today;
        this.DocDueDate = today;
        this.TaxDate = today;
        this.ReqDate = today;
        this.ReqType = '12';
        this.Requester = '';
        this.ReqName = '';
        this.Branch = '';
        this.BranchName = '';
        this.Department = '';
        this.DepartmentName = '';
        this.Email = '';
        this.Notify = 'N';
        this.isSelectTo = false; // para validacion
        this.isSelectToActive = false; // para validacion copiar a - no actualizar precios
        this.isSelectOf = false; // para validfacion
        this.isSelectOfActive = false; // para validacion copiar de - no actualizar precios
        this.SlpCode = "";
        this.SlpName = "";
        this.CntctCode = "";
        this.CntctName = "";
        this.OwnerCode = "";
        this.Status = "";
        this.OwnerName = "";
        this.Comments = "";
        this.CommentsAccount = ""
        this.Subtotal = 0;
        this.DiscountPercent = 0;
        this.Discount = 0;
        this.TaxeDefaultPartner = '';
        this.TaxeRateDefaultPartner = 0;
        this.TaxNameDefaultPartner = '';
        this.OcrCode2DefaultPartner = '';
        this.AcctCodeDefaultPartner = '';
        this.CogsAcctDefaultPartner = '';
        this.AcctCodeNameDefaultPartner = '';
        this.CogsAcctNameDefaultPartner = '';
        this.Taxes = 0;
        this.Total = 0;
        this.DpmAmnt = 0;
        this.TotalCopy = 0;
        this.Items = [];
        this.ItemsPayments = [];
        this.CheckList = [];
        this.permissions = {};
        this.servicesToUpdate = 1; // 1 = update all  2 = not update all
        this.DefaultAcctCode = '';
        this.metodoPago = 0;
        this.GroupNum = 0;
        this.GroupName = "";
        this.PymCode = "";
        this.PymName = "";
        this.ExtraDays = 0;

        this.indexRowDetails = ""; // index to details when press any action
        this.LastLineNumItems = -1;
        this.SelectOf = '';

        // Traslados

        this.Filler = "";
        this.FillerName = "";
        this.ToWhsCode = "";
        this.ToWhsCodeName = "";
        this.JrnlMemo = "";
        this.GroupNumTraslado = "";
        this.GroupNumTrasladoName = "";

        this.PickRmrk = '';

        this.wareHouseFinalOptional = false;
        this.wareHouseFinalOptionalValue = "";

        this.Transit = '1';
        this.DocNumCEDIS = '';
        this.DocEntryCEDIS = '';
        this.WarehouseCEDIS = '';

        //Pagos

        this.TransId = "";
        this.CounterRef = "";
        this.NoDocSum = 0;
        this.BpAct = "";
        this.BpActName = "";
        this.BpActFormatCode = "";

        this.BpActCopy = "";
        this.BpActNameCopy = "";
        this.BpActFormatCodeCopy = "";

        this.PayNoDoc = false;


        this.CashSum = 0;
        this.CreditSum = 0;
        this.CheckSum = 0;
        this.TrsfrSum = 0;
        this.totalRecibido = 0;
        this.totalDocumento = 0;
        this.totalPago = 0;
        this.totalRestante = 0;

        this.TrsfrAcct = "";
        this.TrsfrAcctName = "";
        this.TrsfrAcctFormatCode = "";
        this.TrsfrDate = today;
        this.TrsfrRef = "";


        this.CheckAcct = "";
        this.CheckAcctName = "";
        this.CheckAcctFormatCode = "";

        this.CashAcct = "";
        this.CashAcctName = "";
        this.CashAcctFormatCode = "";

        //ENTRADA DE MERCANCIA CASCOS       
        this.SerieArray2 = [];
        this.SerieName2 = "";
        this.SerieCode2 = "";
        this.NextFolio2 = "";
        this.DocType2 = "";
        this.Casco = 0;
        this.DocStatusCasco = "";

        //ENTRADA DE MERCANCIA CASCOS       
        this.SerieArray3 = [];
        this.SerieName3 = "";
        this.SerieCode3 = "";
        this.NextFolio3 = "";

        // campo para poder diferenciar  en autorizar y crear auhorizado para traslados
        this.ObjType = "";

        //UserFields

        this.userFields = new UserFields();
        this.userFieldsItem = new UserFieldsItem();
        //Propiedar para buscar Item con un Like
        this.searchItem = "";
        //Propuiedad para entrada y salida de Mercancia
        this.Ref2 = '';
        this.service = [];
        this.refreshCascos = false;
        this.partnerSelected = false;
        this.itemSelected = false;
        //Validar almacén selecionado
        this.fillWhsSelected = false;
        this.toWhsSelected = false;
        //Cuenta puente y asociada para Entrada casco 
        this.CashAccount = ''; // Cuenta pago
        this.ControlAccount = '';  // Cuenta asociada
        //Nueva vista para selectTo
        this.newView = '';
        this.U_FMB_Auto = '';
        //Nombre del modelo de autorización
        this.StepCode = '';
        this.WtmName = '';
        //Factura de reserva de clientes
        this.ReserveInvoice = 'tNO';
        //Numero de transacion
        this.transactionId = '';
        this.PaidToDate = 0;
        this.BackOrder = '';
        this.PartDelivr = '';
        this.Confirmed = true;
        this.PartSupply = true;
        //#region ######### TIMBRA-ONE ############################################################
        this.U_UDF_UUID = '';
        this.U_FMB_TIPO_REL = '00';
        this.U_FMB_UUID_RELACIONADO = [];
        this.U_FMB_SELLO = '';
        this.U_FMB_FOLIO = '';
        this.U_FMB_SERIE = '';
        this.U_FMB_TIPO_RELACION = [];
        this.IsCancelCFDI = '';
        //#endregion

        //#region ######### CAMPOS EMPRESA ###########################################################

        this.U_TipoSalida = '';
        this.U_TipoSalidaOptions = [];
        //#endregion

        this.Addresses = [];
        // Counter
        this.folio = '';
        // Pagos con tarjeta de credito
        this.PaymentsCreditCards = [new CreditCards()];

        this.ToolBar = new ToolBar();

        this.StatusCFDI = false;
        this.IsCancelSAP = false;
        this.Canceled = 'N';

        //#region ######### CARTA PORTE ###########################################################
        this.U_FMB_FOLIO_PORTE = '';
        //#endregion

        // Gestión de Citibanamex
        this.U_FMB_Bank_Status = 'N';

        //DELIVERY AUTHORIZATION
        this.DeliveryAuthorization = 'N';

        //Documento Relacionado
        this.U_FMB_RelatedFolio = '';

        //#region ######### MRP ###########################################################
        this.DpstType = '';
        this.ObjAbs = -1;
        this.FromDate = '';
        this.ToDate = '';
        this.FromDate3 = '';
        this.ToDate3 = '';
        this.ItmFrom1 = '';
        this.ItmTo1 = '';
        this.ItmGroup = '';
        this.CardFrom1 = '';
        this.CardTo1 = '';
        //#endregion

        // Precios de Entrega
        this.AgentCode = '';
        this.AgentName = '';
        this.AgentSelected = false;
        this.DocTotal = 0;
        this.landedCosts = new LandedCosts();

        //  refill doc fields 
        this.UserName = ''
    }
};

//#endregion ################### SUGGEST REFILL DOCUMENTS ################ ✔




//DISCOUNT PERDIOD AND QUANTITY
export class DISCOUNT_PERIOD_QTY {
    constructor() {
        this.LINENUM = -1
        this.Price = -1
        this.Discount = -1
        this.FromDate = null
        this.ToDate = null
        this.AutoUpdt = 'N'
        this.SPP2_Discount = []//SPP2_DISCOUNT
    }
}

export class SPP2_DISCOUNT {
    constructor() {
        this.Amount = 0
        this.Price = 0
        this.Discount = 0
    }

}


export class WareHouseModel {
    constructor() {
        this.WhsCode = '';
        this.WhsName = '';
        this.Inactive = 'N';
        this.DropShip = 'N';
        this.Location = '';
        this.Nettable = 'Y';
        this.Street = '';
        this.StreetNo = '';
        this.Block = '';
        this.Building = '';
        this.ZipCode = '';
        this.City = '';
        this.County = '';
        this.Country = '';
        this.State = '';
        this.FedTaxID = '';
        this.GlblLocNum = '';
        this.TaxOffice = '';
        this.Address2 = '';
        this.Address3 = '';

        this.ExpensesAc = '';
        this.RevenuesAc = '';
        this.BalInvntAc = '';
        this.SaleCostAc = '';
        this.TransferAc = '';
        this.VarianceAc = '';
        this.PriceDifAc = '';
        this.NegStckAct = '';
        this.DecreasAc = '';
        this.IncreasAc = '';
        this.ReturnAc = '';
        this.FrRevenuAc = '';
        this.FrExpensAc = '';
        this.ExchangeAc = '';
        this.BalanceAcc = '';
        this.DecresGlAc = '';
        this.IncresGlAc = '';
        this.WipAcct = '';
        this.WipVarAcct = '';
        this.WipOffset = '';
        this.StockOffst = '';
        this.StokRvlAct = '';
        this.StkOffsAct = '';
        this.CostRvlAct = '';
        this.CstOffsAct = '';
        this.ExpClrAct = '';
        this.StkInTnAct = '';
        this.ShpdGdsAct = '';
        this.ARCMAct = '';
        this.APCMAct = '';
        this.ARCMFrnAct = '';
        this.APCMFrnAct = '';
    }
}

export class ReabsDetails {
    constructor() {
        this.lines = []
    }
}

export class CutTransferDetails {
    constructor() {
        this.UsrOri = '';
        this.UsrDes = '';
        this.ShiftType = '';
        this.ReassignTo = '';
        this.CreateDate = '';
        this.AcceptDate = '';
        this.Status = 'P';
        this.IdOTRC = '';
        this.operations = [];
    }
}

// LISTA DE PRECIOS
export class PriceListsModel {
    constructor() {
        this.isNew = true;
        this.ListNum = 0;
        this.ListName = '';
        this.BASE_NUM = null;
        this.Factor = 1.0;
        this.RoundSys = '0';
        this.RoundRule = 'R';
        this.GroupCode = '1';
        this.ValidFor = 'Y';
        this.PrimCurr = 'MXP';
    }
}

// GRUPO DE ARTICULOS
export class ItemsGroupCodeModel {
    constructor() {
        this.isNew = true;
        this.ItmsGrpCod = '';
        this.ItmsGrpNam = '';
        this.UgpEntry = '';
        this.PlaningSys = 'N';
        this.PrcrmntMtd = 'B';
        this.CompoWH = 'B';
        this.OrdrIntrvl = '';
        this.OrdrMulti = '';
        this.MinOrdrQty = '';
        this.RuleCode = '';
        this.LeadTime = '';
        this.ToleranDay = '';
        this.InvntSys = 'A';
        // CUENTAS
        this.ExpensesAc = '';
        this.RevenuesAc = '';
        this.BalInvntAc = '';
        this.SaleCostAc = '';
        this.TransferAc = '';
        this.VarianceAc = '';
        this.PriceDifAc = '';
        this.NegStckAct = '';
        this.DecreasAc = '';
        this.IncreasAc = '';
        this.ReturnAc = '';
        this.FrRevenuAc = '';
        this.FrExpensAc = '';
        this.ExchangeAc = '';
        this.BalanceAcc = '';
        this.DecresGlAc = '';
        this.IncresGlAc = '';
        this.WipAcct = '';
        this.WipVarAcct = '';
        this.WipOffset = '';
        this.StockOffst = '';
        this.StokRvlAct = '';
        this.StkOffsAct = '';
        this.CostRvlAct = '';
        this.CstOffsAct = '';
        this.ExpClrAct = '';
        this.StkInTnAct = '';
        this.ShpdGdsAct = '';
        this.ARCMAct = '';
        this.APCMAct = '';
        this.ARCMFrnAct = '';
        this.APCMFrnAct = '';
    }
}




// #region    ################## TIMBRADO DE NOMINA  ################ ✔
// EMPTY MODEL
// export class TimbradoNomina {
//     constructor() {
//         // Atributos del Comprobante
//         this.certificado = "";
//         this.descuento = 0;
//         this.exportacion = "";
//         this.fecha = "";
//         this.lugarExpedicion = "";
//         this.metodoPago = "";
//         this.moneda = "";
//         this.noCertificado = "";
//         this.sello = "";
//         this.subTotal = 0;
//         this.tipoDeComprobante = "";
//         this.total = 0;
//         this.version = "";

//         // CfdiRelacionados
//         this.cfdiRelacionados = {
//             tipoRelacion: "",
//             relacionados: [] // Array de UUIDs
//         };

//         // Emisor
//         this.emisor = {
//             nombre: "",
//             regimenFiscal: "",
//             rfc: ""
//         };

//         // Receptor
//         this.receptor = {
//             nombre: "",
//             rfc: "",
//             usoCFDI: "",
//             regimenFiscalReceptor: "",
//             domicilioFiscalReceptor: ""
//         };

//         // Conceptos
//         this.conceptos = [
//             {
//                 cantidad: 0,
//                 claveProdServ: "",
//                 claveUnidad: "",
//                 descripcion: "",
//                 descuento: 0,
//                 importe: 0,
//                 objetoImp: "",
//                 valorUnitario: 0
//             }
//         ];

//         // Nomina
//         this.nomina = {
//             version: "",
//             tipoNomina: "",
//             fechaPago: "",
//             fechaInicialPago: "",
//             fechaFinalPago: "",
//             numDiasPagados: 0,
//             totalPercepciones: 0,
//             totalDeducciones: 0,
//             totalOtrosPagos: 0,

//             emisor: {
//                 registroPatronal: ""
//             },

//             receptor: {
//                 curp: "",
//                 numSeguridadSocial: "",
//                 fechaInicioRelLaboral: "",
//                 antigüedad: "",
//                 tipoContrato: "",
//                 sindicato: "",
//                 tipoJornada: "",
//                 tipoRegimen: "",
//                 numEmpleado: "",
//                 departamento: "",
//                 puesto: "",
//                 riesgoPuesto: "",
//                 periodicidadPago: "",
//                 cuentaBancaria: "",
//                 salarioBaseCotApor: 0,
//                 salarioDiarioIntegrado: 0,
//                 claveEntFed: ""
//             },

//             percepciones: {
//                 totalSueldos: 0,
//                 totalGravado: 0,
//                 totalExento: 0,
//                 percepcion: [
//                     {
//                         tipoPercepcion: "",
//                         clave: "",
//                         concepto: "",
//                         importeGravado: 0,
//                         importeExento: 0
//                     }
//                 ]
//             },

//             deducciones: {
//                 totalOtrasDeducciones: 0,
//                 totalImpuestosRetenidos: 0,
//                 deduccion: [
//                     {
//                         tipoDeduccion: "",
//                         clave: "",
//                         concepto: "",
//                         importe: 0
//                     }
//                 ]
//             },

//             otrosPagos: [
//                 {
//                     tipoOtroPago: "",
//                     clave: "",
//                     concepto: "",
//                     importe: 0,
//                     subsidioAlEmpleo: {
//                         subsidioCausado: 0
//                     }
//                 }
//             ]
//         };
//     }
// }

// FILL MODEL
export class TimbradoNomina {

    constructor() {
        const today = moment(new Date()).format('YYYY-MM-DD');

        // Comprobante
        this.certificado = "";
        this.noCertificado = "";
        this.sello = "";
        this.UUID = "";
        this.IdNom = -1;

        this.exportacion = "01";
        this.fecha = today;
        this.lugarExpedicion = "97390";
        this.metodoPago = "PUE";
        this.metodoPagoOptions = [{ value: 'PUE', label: 'PUE' }, { value: 'PPD', label: 'PPD' }]
        this.moneda = "MXN";

        this.tipoDeComprobante = "N";

        this.total = 3173.14;
        this.descuento = 72.64;
        this.subTotal = 3245.78;
        this.version = "4.0";


        // CfdiRelacionados
        this.cfdiRelacionados = {
            tipoRelacion: "04",
            relacionados: ["E7ABDA06-2B7A-4BAE-95BE-BAC7692E4227"]
        };

        // Emisor
        this.emisor = {
            nombre: "MIEMPRESA",
            regimenFiscal: "000",
            rfc: "XAXXXAXAAAX",

        };

        // Receptor
        this.receptor = {
            nombre: "",
            rfc: "",
            usoCFDI: "",
            regimenFiscalReceptor: "",
            domicilioFiscalReceptor: ""
        };

        // Conceptos
        this.conceptos = [
            {
                cantidad: 1,
                claveProdServ: "84111505",
                claveUnidad: "ACT",
                descripcion: "Pago de nómina",
                descuento: 72.64,
                importe: 3245.78,
                objetoImp: "01",
                valorUnitario: 3245.78
            }
        ];

        // Nomina
        this.nomina = {
            version: "1.2",
            tipoNomina: "E",
            fechaPago: "2021-11-26",
            fechaInicialPago: "2021-11-22",
            fechaFinalPago: "2021-11-28",
            numDiasPagados: 1.000,
            totalPercepciones: 3245.78,
            totalDeducciones: 72.64,
            totalOtrosPagos: 0,

            emisor: {
                registroPatronal: "G9312760104"
            },

            receptor: {
                curp: "PECH950925HYNCNC05",
                cuentaBancaria: "000000000000000000",

                numSeguridadSocial: "50149566684",
                fechaInicioRelLaboral: "2021-05-27",
                antiguedad: "P26W",
                tipoContrato: "01",
                sindicato: "SINDICATO UNICO",
                tipoJornada: "03",
                tipoRegimen: "02",
                numEmpleado: "3238",
                departamento: "CORRUGADORA",
                puesto: "Operador de Cocina",
                riesgoPuesto: "4",
                periodicidadPago: "99",

                salarioBaseCotApor: 350.07,
                salarioDiarioIntegrado: 350.07,
                claveEntFed: "YUC"
            },

            percepciones: {

                totalGravado: 667.72,
                totalExento: 2578.06,
                totalSueldos: 3245.78,
                percepcion: [
                    {
                        clave: "500",
                        concepto: "AGUINALDO",
                        importeExento: 2578.06,
                        importeGravado: 0.00,
                        tipoPercepcion: "002",

                    },
                    {
                        clave: "501",
                        concepto: "GRATIFICACION ANUAL",
                        importeExento: 0.00,
                        importeGravado: 667.72,
                        tipoPercepcion: "038",

                    }
                ]
            },

            deducciones: {
                totalOtrasDeducciones: 0.00,
                totalImpuestosRetenidos: 72.64,
                deduccion: [
                    {
                        clave: "620",
                        tipoDeduccion: "002",
                        concepto: "ISR 174",
                        importe: 72.64
                    }
                ]
            },

            otrosPagos: [
                {
                    tipoOtroPago: "002",
                    clave: "801",
                    concepto: "SUBSIDIO XML",
                    importe: 0.00,
                    subsidioCausado: 0.00
                }
            ]
        };
    }



}

// export class EmployeeNomina {
//     constructor() {
//         this.RecepNombre = "JUAN PÉREZ";
//         this.RecepRfc = "XAXX010101000";
//         this.RecepUsoCfdi = "CN01";
//         this.RecepRegimenFiscal = "605";
//         this.RecepDomicilioFiscal = "01000";

//         this.NomRecepCurp = "PECH950925HYNCNC05";
//         this.NomRecepCuentaBancaria = "000000000000000000";
//         this.NomRecepNumSeguridadSocial = "50149566684";
//         this.NomRecepFechaInicioRelLaboral = "2021-05-27";
//         this.NomRecepAntiguedad = "P26W";
//         this.NomRecepTipoContrato = "01";
//         this.NomRecepSindicato = "SINDICATO UNICO";
//         this.NomRecepTipoJornada = "03";
//         this.NomRecepTipoRegimen = "02";
//         this.NomRecepNumEmpleado = "3238";
//         this.NomRecepDepartamento = "CORRUGADORA";
//         this.NomRecepPuesto = "Operador de Cocina";
//         this.NomRecepRiesgoPuesto = "4";
//         this.NomRecepPeriodicidadPago = "99";
//         this.NomRecepSalarioBaseCotAPor = 350.07;
//         this.NomRecepSalarioDiarioIntegrado = 350.07;
//         this.NomRecepClaveEntFed = "YUC";
//     }
// }

export class EmployeeNomina {
    constructor() {
        const today = moment(new Date()).format('YYYY-MM-DD');
        this.RecepNombre = "";
        this.RecepRfc = "XAXX010101000";
        this.RecepUsoCfdi = "CN01";
        this.RecepRegimenFiscal = "605";
        this.RecepDomicilioFiscal = "";

        this.NomRecepCurp = "";
        this.NomRecepCuentaBancaria = "000000000000000000";
        this.NomRecepNumSeguridadSocial = "";
        this.NomRecepFechaInicioRelLaboral = today;
        this.NomRecepAntiguedad = "";
        this.NomRecepTipoContrato = "";
        this.NomRecepSindicato = "";
        this.NomRecepTipoJornada = "";
        this.NomRecepTipoRegimen = "";
        this.NomRecepNumEmpleado = "";
        this.NomRecepDepartamento = "";
        this.NomRecepPuesto = "";
        this.NomRecepRiesgoPuesto = "";
        this.NomRecepPeriodicidadPago = "";
        this.NomRecepSalarioBaseCotAPor = 0.00;
        this.NomRecepSalarioDiarioIntegrado = 0.00;
        this.NomRecepClaveEntFed = "HGO";
    }
}






//#endregion ################## TIMBRADO DE NOMINA ################ ✔

//#region LEYENDAS FISCALES
export class LeyendasFiscales {
    constructor() {
        this.isNew = true;
        this.disposicionFiscal = '';
        this.norma = '';
        this.textoLeyenda = '';
    }
}
//#endregion

//#region COMERCIO EXTERIOR
export class ComercioExterior {
    constructor() {
        this.CertificadoOrigen = '0';
        this.NumCertificadoOrigen = '';
        this.INCOTERM = '';
        this.Observaciones = '';

        this.Emisor_Calle = '';
        this.Emisor_CodigoPostal = '';
        this.Emisor_Colonia = '';
        this.Emisor_Estado = '';
        this.Emisor_Localidad = '';
        this.Emisor_Municipio = '';
        this.Emisor_NumeroExterior = '';
        this.Emisor_Pais = '';

        this.Receptor_NumRegIdTrib = '';
        this.Receptor_Calle = '';
        this.Receptor_CodigoPostal = '';
        this.Receptor_Colonia = '';
        this.Receptor_Estado = '';
        this.Receptor_Localidad = '';
        this.Receptor_Municipio = '';
        this.Receptor_NumeroExterior = '';
        this.Receptor_Pais = '';

        this.Mercancias = [];
    }
}

export class Mercancias {
    constructor() {
        this.NoIdentificacion = '';
        this.FraccionArancelaria = '';
        this.CantidadAduana = '';
        this.UnidadAduana = '';
        this.ValorUnitarioAduana = '';
        this.ValorDolares = '';
        this.Marca = '';
    }
}
//#endregion

//#region OXXO REFRENCIA
export class OxxoReferenceModel {
    constructor() {
        this.IdOxxoRef = -1;
        this.CreateDate = '';
        this.CreateTime = '';
        this.ObjType = '';
        this.ObjSubType = '';
        this.CreateUser = '';
        this.DocEntry = '';
        this.NumAtCard = '';


        this.Reference = '';
        this.RefNumericPartner = '';
        this.DueDate = '';
        this.RefTotal = '';

    }
}

//#endregion

//#region MODELOS BOT SETTINS 
export class RuleTask {
    constructor() {
        this.IdTask = -1;
        this.Name = '';
        this.TypeRule = 1;
        this.Date = moment(new Date()).format('YYYY-MM-DD');
        this.Hour = moment(new Date()).format('HH:mm');
        this.Interval = '';
        this.CustomTime = moment(new Date()).format('HH:mm');

        this.CustomHour = '';
        this.CustomMinutes = '';
        // payments
        this.FromDate = moment(new Date()).format('YYYY-MM-DD');
        this.ToDate = moment(new Date()).format('YYYY-MM-DD');

        this.StatusTask = 'O';
        this.Users = [];
        this.payloadTask = '';
    }

    static fromDatabase(data) {
        const rule = new RuleTask();
        rule.IdTask = data.idTask || -1;
        rule.Name = data.nameTask || '';
        rule.TypeRule = Number(data.taskType) || 1;
        rule.Date = data.execDate ? String(data.execDate).substring(0, 10) : rule.Date;
        rule.Hour = data.execTime ? String(data.execTime).substring(0, 5) : rule.Hour;
        rule.Interval = data.interval || '';
        rule.CustomHour = data.customHour || '';
        rule.CustomMinutes = data.customMinutes || '';
        rule.StatusTask = data.statusTask || 'O';
        rule.payloadTask = data.payloadTask || '';

        // Regla 10: los usuarios vienen en payloadTask
        if (rule.TypeRule === 10 && rule.payloadTask !== '') {
            try {
                const users = JSON.parse(rule.payloadTask);
                rule.Users = Array.isArray(users) ? users : [];
            } catch (e) {
                rule.Users = [];
            }
        }

        return rule;
    }
}

//#endregion

export class CutInventory {
    constructor() {
        this.CountDate = moment(new Date()).format('YYYY-MM-DD');
        this.Time = moment(new Date()).format('HH:mm');
        this.CountType = '1';
        this.Taker1Type = 'User';
        this.TakerId = '';
        this.TakerName = '';
        this.Series = '';
        this.SeriesName = '';
        this.NextNumber = 0;
        this.Status = 'Abierto';
        this.Ref2 = '';
        this.Items = [];
    }
}

export class ItemCutInventory {
    constructor() {
        this.ItemCode = '';
        this.ItemDesc = '';
        this.WhsCode = '';
        this.BinEntry = '';
        this.BinCode = '';
        this.InWhsQty = 0;
        this.CountQty = '';
        this.Difference = 0;
    }
}